import { observable, action } from "mobx";
import { WBSService } from "modules/WBS/WBSService";
import { WBSModels } from "modules/WBS/WBSModels";
import { FirebaseDocument } from "../../common/models/FirebaseDocument";
import { fromFirestoreToWBS, WBS } from "modules/WBS/models/WBS";
import { Library } from "modules/library/models/Library";
import { DevelopmentStore } from "modules/development/DevelopmentStore";
import { CostPlanStore } from "modules/costPlan/CostPlanStore";
import { LibraryStore } from "modules/library/LibraryStore";
import { WBSRows } from "modules/WBS/models";
import BaseStore from "../../common/BaseStore";
import { default as firebase, firestore } from "common/Firebase";
const _ = require("lodash");
import { Render3dStore } from "modules/render3D/Render3dStore";
import CubeNavigation from "common/assets/images/cube_texture_rubk.png";
import { TakeOffStore } from "modules/takeOff/TakeOffStore";
import { DevelopmentService } from "modules/development/DevelopmentService";
import { CostPlanService } from "modules/costPlan/CostPlanService";
import { Render3dService } from "modules/render3D/Render3dService";
import { WBSPropertiesStore } from "modules/WBS/WBSPropertiesStore";
import { toJS } from "mobx";
import { ToolbarStore } from "modules/WBS/ToolbarStore";
import { ToolbarTaskStore } from "modules/WBS/ToolbarTaskStore";
import { LoginStore } from "modules/login/LoginStore";
import { CustomPropertyStore } from "modules/customProperties/CustomPropertyStore";
import { CalculateWBSService } from "modules/WBS/CalculateWBSService";
import { ProjectStore } from "modules/project/ProjectStore";
import { TQueryDocumentSnapshot } from "common/types/FirebaseTypes";
import { IResourceToUpdate, IWBSRow } from "common/interfaces";
import { EContentType, ERightMenuTab, ERowType, EWBSView } from "common/enums";
import i18n from "i18n";
import { v4 as uuidv4 } from "uuid";
import { divide, roundBy, subtract, sum, times } from "utils/DecimalUtils";

export type TSelectedLine = {
  index: number;
  data?: any;
  WBSRowsIndex: number;
  id: string;
  dataKey?: string;
};

class Store extends BaseStore {
  constructor() {
    super("WBSStore");

    this.WBS = new FirebaseDocument<WBS>(
      "",
      new WBS("", 0, 0, "", 2, "trunc", { percentual: 0, show: false }, 0)
    );
    this.selectedLine = {
      index: -1,
      data: undefined,
      id: "",
      WBSRowsIndex: -1,
    };
    this.oldSelectedLine = {
      index: -1,
      data: undefined,
      id: "",
      WBSRowsIndex: -1,
    };
  }

  @observable dataTable: Array<IWBSRow> = [];
  WBSRows: Array<IWBSRow> = [];
  @observable taskRows: Array<IWBSRow> = [];
  @observable selectedLine: TSelectedLine;
  @observable oldSelectedLine: TSelectedLine;
  @observable selectedLineIndexResources: number = -1;
  @observable loadingDataTable: boolean = false;
  @observable percentAcumulatedEap: number = 0;
  browserTree: Array<any> = [];
  treeNavOpen: Array<any> = ["principal"];
  treeObjs: Array<any> = [];
  paths: Array<any> = [];
  resources: Array<any> = [];
  tasks: Array<any> = [];
  allResources: Array<any> = [];
  allTasks: Array<any> = [];
  imgAux: any = "";
  tableBody: any = null;
  taskTableBody: any = null;
  @observable editingFormula: boolean = false;
  @observable task: any = false;
  @observable currentTab: EWBSView = EWBSView.EAP;
  @observable WBS: FirebaseDocument<WBS>;
  @observable lib: FirebaseDocument<Library>;
  WBSRef: any = null;
  @observable lineNavigator: HTMLElement | false;
  rowCods: Array<{
    tree: string;
    parent: { id: string; index: number };
    parentModel?: { id: string; index: number };
  }> = [];
  @observable rightMenuTab: ERightMenuTab = ERightMenuTab.PROPERTIES;
  @observable resourcesDataTable: any = [];
  @observable tab: number = 0;
  @observable isLoadingOperations: boolean = false;
  orderBy: string = "";
  orderByDirection: string = "desc";
  updateResource: boolean = false;
  @observable loading: boolean = true;
  @observable loadingInsertTask: boolean = false;
  @observable loadingTaskUpload: boolean = false;
  @observable loadingTaskChange: boolean = false;
  @observable display3D: any;
  @observable displayCostPlan: any;
  @observable selectedComposition: any = {};
  @observable newCompositionList: any = [];
  @observable updateComposition: boolean = false;
  @observable replaceComposition: boolean = false;
  /** Propriedade que armazena o índice da linha para reposicionar o scroll da EAP. */
  @observable scrollToIndex?: number = undefined;
  @observable loadingItens: any = false;
  @observable refCollection: any = {};
  @observable taskCollection: any = {};
  @observable focusOrInput: boolean = false;
  @observable possibleLoading: boolean = false;
  @observable totalCost: number = 0;
  @observable wbsName: string = "";
  @observable taskUnitCost: number = 0;
  @observable wbsID: string = "";
  getLineIndex: number = -1;
  stageTotalDictionary: any = {};
  @observable shouldUpdate = true;
  oldState = false;
  @observable replicateModal = false;
  @observable ExportByGroupModal = false;
  @observable subscribeShow = false;
  @observable currentWbsId: string = "";
  @observable currentWbsTotalCost: number = 0;
  @observable currentWbsTotalSaleCost: number = 0;
  @observable cubeIsInitialized: boolean = false;
  allIndexes = {};
  actionsIndex: any = [];
  firstLoad = true;
  maxCodeEap = "1";
  maxCodeEapLength = 39;
  @observable listWbs: FirebaseDocument<WBS>[] = [];
  listWbsId: Array<any> = [];
  @observable processingWbsTotalCost: boolean = false;
  @observable compositionUpdateList: Array<any> = [];
  compositionUpdateProps: { resourceGroup: boolean; alternativeCode: boolean } =
    { resourceGroup: false, alternativeCode: false };
  updateCompositionServiceURL: any =
    process.env.REACT_APP_UPDATE_COMPOSITION_SERVICE_URL;
  @observable CompositionUsedToUpdate: string = "";
  /* Variáveis para atualizar o feedback do processo de recálculo */
  @observable calculatingMessage: string = "";
  @observable alertOpen: boolean = false;
  @observable showAlertQuantityModal: boolean = false;
  @observable tempLineAddQuantity: Array<any> = [];
  @observable tableEAPisScrolling: boolean = false;
  @observable selectedColumn: string = "";
  @observable targetLoad: any = "";

  @action
  reset() {
    this.dataTable = [];
    this.browserTree = [];
    this.paths = [];
    this.resources = [];
    this.tasks = [];
    this.tableBody = null;
    this.taskTableBody = null;
    this.task = false;
    this.taskRows = [];
    this.WBS = new FirebaseDocument<WBS>(
      "",
      new WBS("", 0, 0, "", 2, "trunc", { percentual: 0, show: false }, 0)
    );
    this.selectedComposition = {};
    this.WBSRef = null;
    this.WBSRows = [];
    this.treeNavOpen = ["principal"];
    this.treeObjs = [];
    this.rowCods = [];
    this.selectedLine = {
      index: -1,
      data: undefined,
      id: "",
      WBSRowsIndex: -1,
    };
    this.oldSelectedLine = {
      index: -1,
      data: undefined,
      id: "",
      WBSRowsIndex: -1,
    };
    this.selectedLineIndexResources = -1;
    this.rightMenuTab = ERightMenuTab.PROPERTIES;
    this.scrollToIndex = undefined;
    CostPlanStore.wbsSelected = null;
    this.resourcesDataTable = [];
    this.tab = 0;
    this.maxCodeEap = "1";
    this.maxCodeEapLength = 39;
    this.updateResource = false;
    this.currentTab = EWBSView.EAP;
    this.orderBy = "";
    this.wbsID = "";
    this.orderByDirection = "desc";
    WBSPropertiesStore.WBSProjectDataModel = undefined;
    this.possibleLoading = false;
    this.updateComposition = false;
    this.replaceComposition = false;
    Render3dStore.loadingViewer = false;
    this.listWbs = [];
    this.listWbsId = [];
    this.allIndexes = {};
    this.actionsIndex = [];
    this.firstLoad = true;
    this.cubeIsInitialized = false;
    if (LoginStore.modelMapsSnapshot) LoginStore.modelMapsSnapshot();
    if (LoginStore.filesSnapshot) LoginStore.filesSnapshot();
    if (LoginStore.takeOffFormatedItemsSnapshot)
      LoginStore.takeOffFormatedItemsSnapshot();
    if (LoginStore.wbsRowsSnapshot) LoginStore.wbsRowsSnapshot();
    this.currentWbsId = "";
    this.currentWbsTotalCost = 0;
    this.currentWbsTotalSaleCost = 0;
    this.processingWbsTotalCost = false;
    this.wbsName = "";
    this.calculatingMessage = "";
    this.CompositionUsedToUpdate = "";
    this.subscribeShow = false;
    this.alertOpen = false;
    this.showAlertQuantityModal = false;
    this.tempLineAddQuantity = [];
    this.resetCompositionUpdateData();
  }

  /** Altera o valor da propriedade scrollToIndex para reposicionar o scroll da EAP. */
  @action
  setEAPTableScrollToIndex(index: number) {
    WBSStore.scrollToIndex = index;
    this.selectedColumn = "";
  }

  /** Limpa o valor da propriedade scrollToIndex para não manipular o scroll da EAP. */
  @action
  clearEAPTableScrollToIndex() {
    WBSStore.scrollToIndex = undefined;
    this.selectedColumn = "";
  }

  @action
  updateTaskUnitCost(dataTotal) {
    this.taskUnitCost = sum(
      this.taskUnitCost,
      dataTotal,
      WBSPropertiesStore.getRules(2)
    );
    if (this.task) this.task.unitCost = this.taskUnitCost;
  }

  @action
  changeTempLineAddQuantity(value) {
    this.tempLineAddQuantity = value;
  }

  @action
  changeFunction(value) {
    this.showAlertQuantityModal = value;
    if (value == false) {
      this.changeTempLineAddQuantity([]);
    }
  }

  @action
  setCompositionUpdateList(list: any[]) {
    WBSStore.compositionUpdateList = list;
  }

  @action
  resetCompositionUpdateData() {
    this.compositionUpdateList = [];
    WBSStore.compositionUpdateProps = {
      resourceGroup: false,
      alternativeCode: false,
    };
  }

  @action
  subscribeShowChange(show: boolean) {
    this.subscribeShow = show;
  }

  @action
  refreshListWbs() {
    this.listWbs = [];
  }

  @action
  async setWbsName() {
    this.wbsName = await WBSService.getWbsName();
  }

  @action
  openEAP() {
    this.currentTab = EWBSView.EAP;
    this.display3D = "hidden";
    this.displayCostPlan = "visible";
  }

  @action
  openViewer3D() {
    this.currentTab = EWBSView.VIEWER_3D;
    this.display3D = "visible";
    this.displayCostPlan = "hidden";
  }

  async changeCurrentCostPlan(id: string) {
    this.dataTable = [];
    ToolbarStore.clearUndoList();
    if (this.task == false) {
      this.changeCurrentWbsTotalCost();
      if (this.currentWbsId != id) {
        await WBSService.selectWbs(id);
      }
    }
  }

  @action
  async changeCurrentWbsTotalCost() {
    this.processingWbsTotalCost = true;

    if (this.currentWbsId != "") {
      const wbsData = await firestore
        .collection("wbsProjectBudget")
        .doc(this.currentWbsId)
        .get();

      const data = wbsData.data();
      if (data) {
        this.currentWbsTotalCost = data.totalCost;
        this.totalCost = data.totalCost;
        this.currentWbsTotalSaleCost = data.totalSale;
      }
    }

    this.processingWbsTotalCost = false;
  }

  get cubeIsVisible(): boolean {
    return (
      (this.display3D === "visible" || WBSStore.cubeIsInitialized) &&
      LibraryStore.hasActive3DModels &&
      !TakeOffStore.layerTakeOffList
    );
  }

  private async orderListByTimestamp(data: TQueryDocumentSnapshot[]) {
    let list: Array<FirebaseDocument<WBS>> = [];

    for (let doc of data) {
      list.push(fromFirestoreToWBS(doc));
    }

    list.sort((a, b) => {
      return this.subtractSeconds(a.data.createdAt, b.data.createdAt);
    });

    return list;
  }

  private subtractSeconds(
    createdAtA = { seconds: 0 },
    createdAtB = { seconds: 0 }
  ) {
    return createdAtA.seconds - createdAtB.seconds;
  }

  @action
  async getWbsById(id) {
    this.refreshListWbs();
    let data = await firestore
      .collection("wbsProjectBudget")
      .where("development", "==", id)
      .get();

    let list = await this.orderListByTimestamp(data.docs);
    this.listWbs = [...list];
  }

  comparePosition(a, b) {
    if (a.data().postion < b.data().postion) {
      return -1;
    }
    if (a.data().postion > b.data().postion) {
      return 1;
    }
    return 0;
  }

  @action
  setWbsID(wbsID: string) {
    this.wbsID = wbsID;
  }

  loadDatatableWithRightFormat(WBSRows: Array<IWBSRow>) {
    WBSRows = WBSRows.map((data, index) => {
      data.WBSRowsIndex = index;
      return data;
    });
    this.WBSRows = WBSRows;
    // Carrega a lista com apenas as informações necessárias para a tela principal
    let newList = this.recursiveLoading(WBSRows, -1, "");

    if (this.firstLoad) {
      let wbsId = WBSStore.WBS !== undefined ? WBSStore.WBS.id : "";
      if (!wbsId) {
        this.dataTable = [];
        return;
      }
      // Percorre os indices para alterar os valores caso o index esteja errado
      for (const [key, value] of Object.entries(this.allIndexes)) {
        let item: any = value;
        for (let i = 0; i < item.length; i++) {
          if (item[i].index != i) {
            this.actionsIndex.push(
              firestore
                .collection("wbsProjectBudget")
                .doc(wbsId)
                .collection("rows")
                .doc(item[i].id)
                .update({ rowIndex: i })
            );
          }
        }
      }
    }
    // Ordena a lista pelo index da arvore
    let ordened = this.orderListByTree(newList);
    ordened = this.addIndexToList(ordened);
    this.maxCodeEapLength =
      (this.maxCodeEap.replace(/\./g, "").length +
        (this.maxCodeEap.match(/\./g) || []).length / 2) *
        7 +
      25;

    this.dataTable = ordened;
  }

  handleKeyDown = (index, dataKey, keyTO, ms, e) => {
    e = e || window.event;
    let key = "which" in e ? e.which : e.keyCode,
      activeElement = document.activeElement as any;
    if (key === 38) {
      if (activeElement) activeElement.blur();
      if (keyTO) {
        clearTimeout(keyTO);
        keyTO = null;
      }
      keyTO = setTimeout(
        () => WBSStore.setSelectedLine(index - 1, dataKey, false),
        ms
      );
    } else if (key === 40) {
      if (activeElement) activeElement.blur();
      if (keyTO) {
        clearTimeout(keyTO);
        keyTO = null;
      }
      keyTO = setTimeout(
        () => WBSStore.setSelectedLine(index + 1, dataKey, false),
        ms
      );
    }
  };

  checkNegativeNumber(value) {
    let number = Number(value.replace(/\./g, "").replace(/\,/g, "."));
    if (number < 0) {
      return number * -1;
    }
    return number;
  }

  async handleInputBlur(
    line,
    ref,
    dataKey,
    hash,
    currentClmn,
    onChange,
    valueToSave,
    isTask,
    numeric?
  ) {
    if (line.data.fromModelMap && dataKey === "quantity") return currentClmn;
    if (onChange && valueToSave) {
      let newValue = null;
      if (valueToSave.nameValue === "bdi" && valueToSave.value === "") {
        newValue = null;
      } else {
        newValue = numeric
          ? this.checkNegativeNumber(valueToSave.value)
          : valueToSave.value;
      }
      onChange(
        isTask
          ? WBSStore.taskRows[valueToSave.index]
          : WBSStore.dataTable[valueToSave.index],
        valueToSave.index,
        ref,
        dataKey,
        newValue
      );
    }
    return "";
  }

  handleInputFocus = (state, value, hash, e, numeric?) => {
    if (e.target == null) return;
    state.currentClmn = hash;

    WBSStore.troca(WBSStore.selectedLine); // Airton

    if (numeric) {
      let newValue: any = parseFloat(
        e.target.value.replace(/\./g, "").replace(",", ".")
      );
      newValue = isNaN(newValue) ? null : newValue;
      state.numericInputValue = newValue;
      state.inputValue = value === undefined ? newValue : value;
    } else state.inputValue = value === undefined ? e.target.value : value;

    return state;
  };

  orderListByTree(newList: Array<any>) {
    newList = newList.sort((a, b) => {
      let explodedA = a.data.tree.split(".");
      let explodedB = b.data.tree.split(".");
      let i = 0;
      let returnValue: any = null;
      do {
        returnValue =
          +explodedA[i] > +explodedB[i]
            ? 1
            : +explodedB[i] > +explodedA[i]
            ? -1
            : null;
        if (returnValue == null) {
          if (!explodedA[i]) {
            returnValue = -1;
          } else if (!explodedB[i]) {
            returnValue = 1;
          }
        }
        i++;
      } while (returnValue == null);

      return returnValue;
    });
    for (let i = 0; i < newList.length; i++) {
      newList[i].index = i;
    }
    return newList;
  }

  orderListByRowIndex(newList: Array<any>) {
    return newList.sort((a, b) => a.data.rowIndex - b.data.rowIndex);
  }

  /*
    Carrega a lista que vai aparecer na tela para o usuário
    Isso retira as tasks, que só serão renderizadas ao entrar na outra tela.
    Aqui também já preenche a informação do treeView
  */
  recursiveLoading(WBSRows: Array<any>, id: any, treeId: string) {
    let newList = new Array<any>();
    let filtred = WBSRows.filter((r) => r.data.parentStage == id);

    for (let i = 0; i < filtred.length; i++) {
      if (this.firstLoad) {
        if (!this.allIndexes[filtred[i].data.parentStage]) {
          this.allIndexes[filtred[i].data.parentStage] = [];
        }
        this.allIndexes[filtred[i].data.parentStage].push({
          index: filtred[i].data.rowIndex,
          id: filtred[i].id,
        });
      }
      filtred[i].data.tree =
        treeId == ""
          ? "" + (filtred[i].data.rowIndex + 1)
          : treeId + "." + (filtred[i].data.rowIndex + 1);
      if (filtred[i].data.tree.length > this.maxCodeEap.length) {
        this.maxCodeEap = filtred[i].data.tree;
      }
      // Apenas etapas tem filhos, para acha-los enviamos para sua função o seu id
      if (filtred[i].data.rowType == ERowType.STAGE) {
        newList.push(
          ...this.recursiveLoading(WBSRows, filtred[i].id, filtred[i].data.tree)
        );
      }
    }
    newList.push(...filtred);
    return newList;
  }

  ouvinte(fetch: boolean = true, createdWBS?) {
    if (createdWBS) {
      WBSService.newUpdateWBS(fetch, createdWBS);
    } else {
      WBSService.newUpdateWBS(fetch);
    }
  }

  @action
  setCurrentWbsId(id) {
    this.currentWbsId = id;
  }

  resetUpdateCompositions() {
    WBSService.resetUpdateCompositions(
      this.WBSRef,
      WBSStore.WBS.data.updateCompositions
    );
  }

  /**
   * Inicia o processo de atualizar as composições escolhidas da EAP
   * com os dados vindos do banco de composições e exibe seu progresso
   * na tela.
   * @param rateLibraryId ID do banco de composições
   * @param rowCodesList Lista de códigos das composições
   * @param changeDescription Deve alterar as descrições na EAP?
   */
  async updateCompositionsWithRateLibrary(
    rateLibraryId: string,
    rowCodesList: string[],
    changeDescription: boolean
  ) {
    const wbsId = this.currentWbsId;

    WBSStore.displayUploadOfUpdateComposition(
      "updateCompositions",
      rowCodesList.length
    );
    await WBSService.sendToUpdateCompositions(
      wbsId,
      rateLibraryId,
      changeDescription,
      rowCodesList,
      this.compositionUpdateProps.resourceGroup,
      this.compositionUpdateProps.alternativeCode
    );
    this.resetCompositionUpdateData();
  }

  @action
  async getWBS(
    fetchCostPlans = true,
    createdWBS?,
    responses?
  ): Promise<Boolean> {
    // Não recarrega enquanto tiver erro nos indexes
    if (this.actionsIndex.length != 0) return false;
    this.loadingItens = true;
    let response;
    if (responses) {
      response = responses;
    }
    this.wbsID = response.ref.id;

    if (fetchCostPlans) {
      CostPlanStore.importCostPlanFileProgess = "0";
      CostPlanStore.importCostPlanFileStatus = "complete";
      CostPlanStore.setImportLoading(-1);
      CostPlanStore.setOpenGridDialog(false);
      CostPlanStore.setOpenBlankWbs(false);
      await CostPlanService.fetchCostPlans();
    }
    if (response) {
      this.changeCurrentWbsTotalCost();
      this.totalCost = this.currentWbsTotalCost;
      this.WBSRef = response.ref;
      let tmpWBSRef: any = [];
      for (let i = 0; i < response.rows.length; i++) {
        let tmpRow: any = {};
        tmpRow = response.rows[i];
        tmpRow.WBSRowsIndex = i;
        tmpWBSRef.push(tmpRow);
      }
      this.WBSRows = tmpWBSRef;
      if (this.WBSRows.length > 0) {
        if (WBSStore.task) {
          await WBSStore.updateTaskRows(WBSStore.task);
        }
        WBSStore.isLoadingOperations = false;
        // WBSStore.loading = false;
        this.dataTable = [];
        this.loadDatatableWithRightFormat(tmpWBSRef);
        if (this.firstLoad) {
          await Promise.all(this.actionsIndex);
        }
        this.actionsIndex = [];
      } else {
        await this.fillEmptyWbs();
      }

      if (this.dataTable.length == 0) {
        await this.fillEmptyWbs();
      }

      if (DevelopmentStore.updateResources) {
        DevelopmentStore.updateResources = false;
        await this.refactorUpdateResources();
      }

      let index = this.WBSRows.findIndex((r) => {
        return (
          r.data &&
          this.selectedLine.data &&
          r.data.parentStage == this.selectedLine.data.parentStage &&
          r.data.parentTask == this.selectedLine.data.parentTask &&
          r.data.rowIndex == this.selectedLine.data.rowIndex
        );
      });

      if (index != -1) {
        if (
          this.selectedLine.id != this.WBSRows[index].id ||
          !this.shallowEqual(this.selectedLine.data, this.WBSRows[index].data)
        ) {
          this.selectedLine = {
            index: this.WBSRows[index].WBSRowsIndex,
            ...this.WBSRows[index],
          };
        }
      }

      this.setSelectedLine(this.selectedLine.index, this.selectedColumn);

      this.loadingItens = false;
      this.loading = false;
      this.firstLoad = false;
      return true;
    }
    this.firstLoad = false;
    this.loadingItens = false;
    this.loading = false;
    return false;
  }

  @action
  setPercentageEap(value: number) {
    this.percentAcumulatedEap = value;
  }

  shallowEqual(object1, object2) {
    const keys1 = Object.keys(object1);
    const keys2 = Object.keys(object2);

    if (keys1.length !== keys2.length) {
      return false;
    }

    for (let key of keys1) {
      if (object1[key] !== object2[key]) {
        return false;
      }
    }
    return true;
  }
  async refactorUpdateResources() {
    const resourceContentIds: any = [];
    const resourcesAndTasks: any = [];

    for (const row of this.WBSRows) {
      if (
        row.data.rowType === ERowType.RESOURCE ||
        row.data.rowType === ERowType.TASK
      ) {
        const contentRow = { id: row.id, data: row.data };
        resourcesAndTasks.push(contentRow);
        if (
          row.data.rowType === ERowType.RESOURCE &&
          row.data.contentId &&
          resourceContentIds.indexOf(row.data.contentId) === -1
        ) {
          resourceContentIds.push(row.data.contentId);
        }
      }
    }

    let dataToUpdate = {
      data: {
        newWbsId: this.WBS.id,
        resourceContentIds: [...resourceContentIds],
        resourcesAndTasks: [...resourcesAndTasks],
      },
    };
    DevelopmentService.updateResourcesAfterCopy(dataToUpdate);
  }

  /**
   * Efetua a chamada em service para recuperar as quantidades totais dos insumos
   */
  async getWBSResources(): Promise<any[]> {
    return await WBSService.getWBSResourceQuantities(this.WBSRef);
  }

  getWBSRowLineByIndex(index: number) {
    if (this.task) {
      return index > -1 && index < this.taskRows.length && this.taskRows[index];
    }
    return index > -1 && index < this.dataTable.length && this.dataTable[index];
  }

  getResourceLineByIndex(index: number) {
    return index > -1 && this.resourcesDataTable[index];
  }

  findRowSiblings(rowId: string, parentStage: number | string): IWBSRow[] {
    return this.WBSRows.filter(
      (r) => r.data.parentStage == parentStage && rowId != r.id
    );
  }

  /**
   * Efetua a atualização em lote dos insumos que tiveram alteração de quantidade total
   * @param resourcesTotals Array de objetos com a chave de identificação do conteúdo do insumo e com a quantidade total atualizada
   */
  async updateWBSResourcesTotals(resourcesTotals): Promise<void> {
    let actions = new Array();
    for (let i = 0; i < resourcesTotals.length; i++) {
      let rowsRef = await this.WBSRef.collection("resources").doc(
        resourcesTotals[i].id
      );
      actions.push({
        type: "set",
        args: [rowsRef, { total: resourcesTotals[i].total }],
      });
    }
    await this.batchActions(actions, false);
  }

  async fillEmptyWbs() {
    let tmpDataTable: any = [];
    let actions = new Array();
    for (let i = 0; i < this.WBS.data.childrenCount; i++) {
      let rowsRef = await this.WBSRef.collection("rows").doc();
      let newRow: any = this.getBlankRow(i);
      newRow.parentStage = -1;
      actions.push({
        type: "set",
        args: [rowsRef, newRow],
      });
      tmpDataTable.push({ WBSRowsIndex: i, id: rowsRef.id, data: newRow });
    }
    await this.batchActions(actions, false);
    this.WBSRows = tmpDataTable;
    this.loadDatatableWithRightFormat(tmpDataTable);
  }

  // Fubção que cria campos em branco apontando pro id da task
  async fillEmptyTask(taskId, nLines = 20) {
    let tmpWBSRows: any = [...this.WBSRows];
    let actions = new Array();
    for (let i = 0; i < nLines; i++) {
      let rowsRef = await this.WBSRef.collection("rows").doc();
      let newRow: any = this.getBlankRow(i);
      newRow.parentTask = taskId;
      actions.push({
        type: "set",
        args: [rowsRef, newRow],
      });
      tmpWBSRows.push({
        WBSRowsIndex: this.WBSRows.length + i,
        id: rowsRef.id,
        data: newRow,
      });
    }
    await this.batchActions(actions, false);
    this.WBSRows = [...tmpWBSRows];
  }

  @action
  async getWBSforRender3D(): Promise<Boolean> {
    let response = await WBSService.getWBSRef(
      DevelopmentStore.developmentSelected.id
    );
    if (response) {
      return true;
    }
    return false;
  }

  get3dModel(id) {
    if (DevelopmentStore.developmentSelected === undefined)
      DevelopmentService.setDevelopmentSelected(id);
    if (!WBSStore.WBS || WBSStore.WBS.id == "") WBSStore.getWBSforRender3D();
    LibraryStore.fetchLibraries(Render3dService.mountRender3D);
  }

  async handleCubeAux() {
    var image = new Image();
    image.src = CubeNavigation;
    this.imgAux = image;
  }
  loader(src, modelId) {
    let temp: any = window;
    if (Render3dStore.xeokitViewer) {
      Render3dStore.xktLoader = new temp.xeokit.XKTLoaderPlugin(
        Render3dStore.xeokitViewer,
        {
          wasmPath: "https://cdn.jsdelivr.net/npm/@xeokit/xeokit-sdk/dist/",
        }
      );
    }
    if (Render3dStore.xktLoader == null) {
      return undefined;
    }

    this.cameraPositioned = false;
    return Render3dStore.xktLoader.load({
      id: modelId,
      src,
      edges: true,
      reuseGeometries: false,
      sao: false,
      pbr: false,
      enableViewFrustumCulling: true,
      targetLodFps: 15,
      backfaces: true,
    });
  }

  /** Atributo para evitar que a camera seja deslocada muitas vezes quando os modelos são federados.  */
  cameraPositioned = false;
  onLoadedModel = async (model, modelId) => {
    model.on("loaded", async () => {
      const metaModel =
        Render3dStore.xeokitViewer.metaScene.metaModels[modelId];
      if (metaModel) {
        Render3dStore.setMetaModel(metaModel);
        const objectId = metaModel.id;
        const objectIds =
          Render3dStore.xeokitViewer.metaScene.getObjectIDsInSubtree(objectId);

        if (!Render3dStore.viewerStarted && !this.cameraPositioned) {
          const aabb = Render3dStore.xeokitViewer.scene.getAABB(objectIds);
          Render3dStore.xeokitViewer.cameraFlight.flyTo(aabb);
          this.cameraPositioned = true;
        }

        Render3dStore.setMetaModelId(objectIds);
      }

      Render3dStore.modelIdCollection.push({
        tag: modelId as never,
        model: modelId,
      });
      if (
        Render3dStore.needIsolateArray == true &&
        Render3dStore.modelIdCollection.length ===
          LibraryStore.libraries3DEnabled.length
      ) {
        Render3dStore.needIsolateArray = false;
        TakeOffStore.layerTakeOffList = false;
        let isolateArray = [...Render3dStore.isolateArray];

        if (isolateArray.length == 0) {
          Render3dStore.isolateElements([]);
        } else {
          await this.timeout(200);
          await Render3dStore.isolateElements(isolateArray);
        }
        WBSStore.rightMenuTab = ERightMenuTab.PROPERTIES;
        Render3dStore.setIsolateArray([]);
      }

      Render3dStore.viewerLoadCounter--;
      let allLoaded = Render3dStore.viewerLoadCounter > 0;
      if (allLoaded == false) {
        Render3dStore.loadingViewer = false;
        Render3dStore.viewerStarted = true;
        Render3dStore.initSectionPlanes();
      }
    });
    let isolateArray = [...Render3dStore.isolateArray];
    if (isolateArray.length == 0) {
      await Render3dStore.fetchIfcItemsAndSetVisibilityByTypes();
    }
  };

  @action
  handle3DTabXeokit() {
    this.verifyLibs();
    if (Render3dStore.xeokitViewer == null) {
      Render3dStore.loadingViewer = this.possibleLoading;
      let temp: any = window;

      const viewer = new temp.xeokit.Viewer({
        canvasId: "xeokitCanvas",
        transparent: true,
        passes: 1,
        pbrEnabled: false,
      });

      new temp.xeokit.FastNavPlugin(viewer, {
        hideEdges: true,
        hideSAO: true,
        hideColorTexture: true,
        hidePBR: true,
        hideTransparentObjects: true,
        scaleCanvasResolution: true,
        scaleCanvasResolutionFactor: 0.5,
        delayBeforeRestore: true,
        delayBeforeRestoreSeconds: 0.5,
      });

      Render3dStore.xeokitViewer = viewer;
      Render3dStore.cubeViewer = new temp.xeokit.NavCubePlugin(viewer, {
        canvasId: "myNavCubeCanvas",
        visible: true,
        cameraFly: true,
        cameraFitFOV: 45,
        cameraFlyDuration: 0.5,
        color: "#A8A8A8",
      });

      this.cubeIsInitialized = true;

      viewer.cameraControl.on("picked", (pickResult) => {
        Render3dStore.unSelectSimilarElements();
        Render3dStore.setSelectedXeokit(pickResult);
      });

      viewer.cameraControl.on("doublePicked", (pickResult) => {
        Render3dStore.unSelectSimilarElements();
        Render3dStore.setSelectedXeokit(pickResult);
      });

      viewer.cameraControl.on("pickedNothing", () => {
        Render3dStore.unSelectSimilarElements();
        Render3dStore.cleanSelectionXeokit();
      });

      viewer.cameraControl.on("doublePickedNothing", () => {
        Render3dStore.unSelectSimilarElements();
        Render3dStore.cleanSelectionXeokit();
      });
    }
  }

  /** Atualiza a propriedade possibleLoading com valor de
   * se há ou não modelos 3D ativos/habilitados.
   */
  verifyLibs() {
    WBSStore.possibleLoading = LibraryStore.hasActive3DModels;
  }

  setPromiseInArray = (pointer, getModel) => (doc) => {
    pointer.data = getModel(doc).data;
    delete pointer.promise;
    return pointer;
  };
  findInArray = (array, reference, getModel) => {
    let itemFound = array.find((itm) => itm.id === reference.id);
    if (!itemFound) {
      array.push(getModel({ id: reference.id }));
      itemFound = array.slice(-1).find(() => true);
      itemFound.promise = new Promise((resolve) => {
        WBSService.getDocRef(reference.path)
          .get()
          .then((doc) => {
            return resolve(this.setPromiseInArray(itemFound, getModel)(doc));
          });
      });
    }

    return itemFound;
  };

  /**
   * Obtém a linha da EAP a partir do ID informado. A busca
   * é feito por todas as linhas presentes no nível da EAP ou
   * que sejam conteúdo de alguma composição.
   * @param {string} id ID da linha desejada
   * @returns {IWBSRow | undefined} A linha desejada caso exista.
   */
  findWBSRowById(id: string): IWBSRow | undefined {
    return this.WBSRows.find((itm) => itm.id === id);
  }

  addIndexToList(list) {
    for (let i = 0; i < list.length; i++) {
      list[i].index = i;
    }
    return list;
  }

  getBlankRow = (index) => ({
    rowType: ERowType.BLANK,
    rowIndex: index,
  });

  getLocation = (ref) => {
    let { id, parent, path } = ref;
    return { id, parent: parent.id, path };
  };

  getModel = (ref, data) => ({ id: ref.id, ref, data: () => data });

  changeDecimalAndRule = async () => {
    WBSService.clearWbsRowsSnapshot();

    this.loading = true;
    if (!this.updateResource) this.updateResource = true;
    WBSPropertiesStore.calculating = true;
    this.calculatingMessage = "Calculando EAP...";

    const onProgress = (data) => {
      this.calculatingMessage = `${
        data.status === "saving" ? "Atualizando" : "Calculando"
      } EAP: ${Math.round(data.progress || 0)}%`;
    };

    const onFinish = () => {
      WBSService.newUpdateWBS(true);
      // O loading eh removido em algum snapshot do WBS ou das rows
      this.calculatingMessage = "";
      this.loading = false;
    };

    const uid = this.WBS.id;
    const rules = { ...WBSPropertiesStore.wbsCalculate };
    const bdi = WBSPropertiesStore.getCurrentWBSBdi();

    CalculateWBSService.startCalculating(
      uid,
      bdi.percentual,
      rules,
      onProgress,
      onFinish
    ).catch((error) => {
      console.error("Error on changeDecimalAndRule", error);
      WBSPropertiesStore.calculating = false;
      this.loading = false;
      this.calculatingMessage = "";
    });
  };

  deleteAllArray(row) {
    WBSStore.WBSRows = WBSStore.WBSRows.filter(
      (r) => r.WBSRowsIndex != row.WBSRowsIndex
    );
    if (row.data.parentTask) {
      WBSStore.taskRows = this.orderListByRowIndex(
        WBSStore.taskRows.filter((t) => t.WBSRowsIndex != row.WBSRowsIndex)
      );
    } else {
      WBSStore.dataTable = WBSStore.dataTable.filter(
        (dt) => dt.WBSRowsIndex != row.WBSRowsIndex
      );
    }
  }

  /** Atualiza o custo unitário dos insumos de um banco de composições escolhido
   * que estão inseridos na EAP.
   */
  async updateRateLibrariesResources(resourcestoUpdate: IResourceToUpdate[]) {
    await WBSService.updateRateLibrariesResourcesOnDataBase(
      this.WBS,
      WBSPropertiesStore.wbsCalculate,
      resourcestoUpdate
    ).catch((error) => {
      console.error("Error on updateRateLibraries", error);
      ProjectStore.showSnack = i18n.wbs.error.updateBudgetResources;
    });

    this.updateComposition = false;
    DevelopmentStore.needUpdateEapValues = true;
  }

  /*
    Função responsável por manter todas as listas atualizadas
  */
  changeAllArray(updateRows, row, needUpdate = true) {
    let dataTableNeedUpdate = false;
    let taskRowsNeedUpdate = false;
    let selectedLineNeedUpdate = false;

    // Chama a função para efetuar o recálculo do insumo
    this.updateResourcesTotalQtt(row);
    try {
      for (var key of Object.keys(updateRows)) {
        if (
          this.selectedLine &&
          this.selectedLine.data &&
          this.selectedLine.data.rowIndex == row.data.rowIndex &&
          this.selectedLine.data.parentStage == row.data.parentStage &&
          this.selectedLine.data.parentTask == row.data.parentTask
        ) {
          selectedLineNeedUpdate = true;
          if (key == "id") {
            this.selectedLine[key] = updateRows[key];
          } else {
            this.selectedLine.data[key] = updateRows[key];
          }
        }
        let index = WBSStore.WBSRows.findIndex(
          (t) =>
            t.data.rowIndex == row.data.rowIndex &&
            t.data.parentStage == row.data.parentStage &&
            t.data.parentTask == row.data.parentTask
        );
        if (index != -1) {
          if (key == "id") {
            WBSStore.WBSRows[index][key] = updateRows[key];
          } else {
            WBSStore.WBSRows[index].data[key] = updateRows[key];
          }
        }
        if (row.data.parentTask) {
          let index = WBSStore.taskRows.findIndex(
            (t) =>
              t.data.rowIndex == row.data.rowIndex &&
              t.data.parentStage == row.data.parentStage &&
              t.data.parentTask == row.data.parentTask
          );
          if (index != -1) {
            taskRowsNeedUpdate = true;
            if (key == "id") {
              WBSStore.taskRows[index][key] = updateRows[key];
            } else {
              WBSStore.taskRows[index].data[key] = updateRows[key];
            }
          }
        } else {
          let index = WBSStore.dataTable.findIndex(
            (dt) =>
              dt.data.rowIndex == row.data.rowIndex &&
              dt.data.parentStage == row.data.parentStage &&
              dt.data.parentTask == row.data.parentTask
          );
          if (index != -1) {
            dataTableNeedUpdate = true;
            if (key == "id") {
              WBSStore.dataTable[index][key] = updateRows[key];
            } else {
              WBSStore.dataTable[index].data[key] = updateRows[key];
            }
          }
        }
      }
      if (needUpdate && dataTableNeedUpdate)
        WBSStore.dataTable[0] = { ...WBSStore.dataTable[0] };
      if (needUpdate) WBSStore.WBSRows[0] = { ...WBSStore.WBSRows[0] };
      if (needUpdate && taskRowsNeedUpdate)
        WBSStore.taskRows[0] = { ...WBSStore.taskRows[0] };
      if (needUpdate && selectedLineNeedUpdate)
        this.selectedLine = { ...this.selectedLine };
    } catch (error) {
      console.log("Error on changeAllArray", error);
    }
  }

  /*
    Função responsável por manter todas as listas atualizadas
  */
  changeWbsRowsArray(updateRows, row, needUpdate = true) {
    try {
      for (var key of Object.keys(updateRows)) {
        let index = WBSStore.WBSRows.findIndex(
          (t) =>
            t.data.rowIndex == row.data.rowIndex &&
            t.data.parentStage == row.data.parentStage &&
            t.data.parentTask == row.data.parentTask
        );
        if (index != -1) {
          if (key == "id") {
            WBSStore.WBSRows[index][key] = updateRows[key];
          } else {
            WBSStore.WBSRows[index].data[key] = updateRows[key];
          }
        }
      }
      if (needUpdate) WBSStore.WBSRows[0] = { ...WBSStore.WBSRows[0] };
    } catch (error) {}
  }

  timeout = (ms) => {
    return new Promise((resolve) => setTimeout(resolve, ms));
  };

  @action
  async updateWBSSubcollection(id, contentId, update, type?) {
    await WBSService.updateWBSSubcollection(
      this.WBSRef,
      id,
      contentId,
      update,
      ...(type && [type])
    );
  }

  /** Remove o vínculo do plano de custo caso não tenha mais nenhuma linha vinculada
   * ao model-map informado.
   */
  async removeCostPlanLink(fromModelMap, deleteRow: boolean = false) {
    try {
      const document = firestore.collection("modelMaps").doc(fromModelMap);
      const snapshot = await document.get();
      const modelMap = snapshot.data();

      if (modelMap) {
        const { currentWbsId } = WBSStore;

        if (modelMap.costPlans.some((uid) => uid === currentWbsId)) {
          let linkCount = this.countLinksAtDataTable(fromModelMap);
          let minLinkCount = deleteRow ? 2 : 1;

          if (linkCount < minLinkCount) {
            let costPlans = modelMap.costPlans.filter(
              (uid) => uid !== currentWbsId
            );
            let costPlansNeedtoBeUpdated =
              modelMap.costPlansNeedtoBeUpdated.filter(
                (uid) => uid !== currentWbsId
              );

            await document.update({
              costPlans,
              costPlansNeedtoBeUpdated,
            });
          }
        }
      }
    } catch (err) {
      console.error("Error on remove model-map link from cost plan:", err);
    }
  }

  /** Percorre todos os elementos que estão no dataTable para ver se precisa ou
   * não remover o model map do plano de custo ou se ainda tem outros inseridos */
  private countLinksAtDataTable(modelMapId: string): number {
    const { dataTable } = WBSStore;
    let mmCount: number = 0;

    for (let i = 0; i < dataTable.length; i++) {
      const line = dataTable[i].data;
      if (line.fromModelMap == modelMapId) {
        let item = dataTable.find((d) => d.id == line.parentStage);
        if (!item) {
          mmCount++;
        } else if (!item.data.fromModelMap) {
          mmCount++;
        }
      }
    }

    return mmCount;
  }

  @action
  async createTaskRowResource(line, ndx, ref, clmn, newValue) {
    // Recupera a task
    let task = this.getListByContent(undefined, WBSStore.task.id);
    let filtred: any = [];
    for (let i = 0; i < task.length; i++) {
      filtred.push(...this.getListByContent(task[i].data.contentId));
    }
    let total = 0;

    if (clmn === "unitCost") {
      total = newValue;
    }

    let actions = new Array();
    let contentId = undefined;
    for (let i = 0; i < filtred.length; i++) {
      let defaultRow = WBSModels.getDefaultRow({
        rowType: ERowType.RESOURCE,
        rowIndex: ndx,
        [clmn]: newValue,
        total,
        contentId,
      });
      defaultRow.parentTask = filtred[i].id;
      contentId = defaultRow.contentId;
      let newLine = WBSStore.WBSRows.findIndex(
        (r) =>
          r.data.parentTask == defaultRow.parentTask && r.data.rowIndex == ndx
      );
      if (newLine != -1) {
        let update = WBSService.removeUndefinedFieldsFromUpdatedRow(
          WBSStore.WBSRows[newLine],
          defaultRow
        );
        defaultRow.id = WBSStore.WBSRows[newLine].id;
        for (var key of Object.keys(update)) {
          if (Object.keys(defaultRow).filter((d) => d == key).length == 0) {
            defaultRow[key] = undefined;
          }
        }
        WBSStore.changeAllArray(defaultRow, WBSStore.WBSRows[newLine]);
        actions.push({
          type: "update",
          args: [
            this.WBSRef.collection("rows").doc(WBSStore.WBSRows[newLine].id),
            update,
          ],
        });
      }
    }

    await this.batchActions(actions, false);

    if (clmn === "unitCost") {
      await this.recursiveUpdateWBSSubcollection(
        this.taskRows[ndx].data.contentId,
        newValue,
        0
      );
    }
  }

  @action
  async createWBSResource(
    line,
    ndx,
    ref,
    clmn,
    newValue,
    clmn2 = "",
    newValue2 = ""
  ) {
    let total = 0;
    if (clmn === "unitCost") {
      total = newValue;
    }
    let actions = new Array();
    let defaultRow = WBSModels.getDefaultRow({
      rowType: ERowType.RESOURCE,
      rowIndex: line.data.rowIndex,
      [clmn]: newValue,
      [clmn2]: newValue2,
      total,
    });
    defaultRow.parentStage = line.data.parentStage;

    let update = WBSService.removeUndefinedFieldsFromUpdatedRow(
      line,
      defaultRow
    );
    actions.push({
      type: "update",
      args: [this.WBSRef.collection("rows").doc(line.id), update],
      arrayChange: () => {
        defaultRow.id = line.id;
        for (var key of Object.keys(update)) {
          if (Object.keys(defaultRow).filter((d) => d == key).length == 0) {
            defaultRow[key] = undefined;
          }
        }
        WBSStore.changeAllArray(defaultRow, line);
      },
    });
    await this.batchActions(actions, false);
    if (clmn === "unitCost") {
      await this.recursiveUpdateWBSSubcollection(
        this.dataTable[ndx].data.contentId,
        newValue,
        0
      );
    }
  }

  @action
  async reverseWBSResourceToBlank(line) {
    const actions = new Array();
    const rowIndex = line.data.rowIndex;
    const index = line.index;

    const defaultRow: any = WBSStore.getBlankRow(rowIndex);
    defaultRow.parentStage = line.data.parentStage;

    let update = WBSService.removeUndefinedFieldsFromUpdatedRow(
      line,
      defaultRow
    );
    actions.push({
      type: "update",
      args: [this.WBSRef.collection("rows").doc(line.id), update],
      arrayChange: () => {
        defaultRow.id = line.id;
        for (var key of Object.keys(update)) {
          if (Object.keys(defaultRow).filter((d) => d == key).length == 0) {
            defaultRow[key] = undefined;
          }
        }
        WBSStore.changeAllArray(defaultRow, line);
      },
    });

    await this.batchActions(actions, true, () => {
      setTimeout(() => {
        WBSStore.setSelectedLine(index, "description", true);
      }, 500);
    });
  }

  batchActions = async (
    actions,
    needLoad,
    callback: Function = async () => {}
  ) => {
    if (needLoad == true) {
      this.shouldUpdate = false;
    }
    let chunk = 400;
    for (let i = 0; i < actions.length; i += chunk) {
      let sliced = actions.slice(i, i + chunk);
      await WBSService.batch(sliced)
        .then(async () => {
          for (let { arrayChange } of sliced) {
            if (arrayChange) await arrayChange();
          }
          await callback();
        })
        .catch((error) => console.log(error));
      await this.timeout(1000);
    }
    if (needLoad == true) {
      this.shouldUpdate = true;
    }
  };

  async setSelectedLineById(id) {
    let selectedLineIndex = this.dataTable.findIndex((r) => r.id === id);
    await this.setSelectedLine(selectedLineIndex);
  }

  /** Define a linha seleciona na tabela.
   * @param {number} index Índice da linha na tabela.
   * @param {string | undefined} dataKey Campo da linha a ser focado.
   * @param {boolean | undefined} needChangeFocus Define se é preciso sair e voltar para linha a ser selecionada com o objetivo de forçar uma renderização.
   */
  @action
  async setSelectedLine(
    index: number,
    dataKey?: string,
    needChangeFocus: boolean = true
  ) {
    // Se não for mudar de coluna e o index for igual a linha selecionada, saiii.
    if (index === this.selectedLine.index && !dataKey) return;
    if (index === undefined) index = this.selectedLine.index;
    if (index === -1) return;

    // Verifica de qual tabela vai selecionar a linga
    let array,
      suffix = "";
    if (this.task) {
      array = this.taskRows;
      suffix = ".t";
    } else {
      array = this.dataTable;
    }
    if (index >= array.length) index = array.length - 1;
    if (array[index] == undefined) {
      return;
    }

    this.selectedLine = {
      index,
      data: array[index].data,
      id: array[index].id,
      dataKey,
      WBSRowsIndex: array[index].WBSRowsIndex,
    };

    if (dataKey) {
      await this.timeout(1);
      // Troca a linha a ser focada (gambiarra)
      if (needChangeFocus) {
        let tempIndex = index == 0 ? index + 1 : index - 1;
        let dataKeyElementTemp = document.getElementById(
          `${tempIndex}.${dataKey}${suffix}`
        );
        dataKeyElementTemp && dataKeyElementTemp.focus();
      }
      // Foca o input
      let dataKeyElement = document.getElementById(
        `${index}.${dataKey}${suffix}`
      );
      dataKeyElement && dataKeyElement.focus();
    }
  }

  @action
  resetSelectedLine(forceRemoveBorders: boolean = false) {
    this.selectedLine = {
      index: -1,
      id: "",
      data: undefined,
      WBSRowsIndex: -1,
    };
  }

  @action
  async changeSelectedLineCode(baseValue, index) {
    let list: any = this.task ? this.taskRows[index] : this.dataTable[index];
    let line = this.WBSRef.collection("rows").doc(list.id);
    let value = baseValue === undefined ? "" : baseValue;
    this.batchActions(
      [
        {
          type: "update",
          args: [line, { rowCode: value }],
          arrayChange: () => {
            WBSStore.changeAllArray({ rowCode: value }, list);
          },
        },
      ],
      false
    );
  }

  @action
  async changeSelectedLineCategory(value) {
    if (this.selectedLine.data.contentType == value) {
      return;
    }

    let actions = new Array(),
      line = this.task
        ? this.taskRows[this.selectedLine.index]
        : this.dataTable[this.selectedLine.index];

    // Se era task tem que exclir as linhas ligadas a ela
    if (line.data.rowType === ERowType.TASK) {
      // Deleta recursivamente as linhas de dentro da task
      actions.push(...this.recursiveRowDelete(line.id));
      // Muda o contentId para um novo, a linha não estará mais ligada a outras linhas.
      let update = {
        contentType: value,
        contentId: WBSModels.getNewUUID(),
        rowType: ERowType.RESOURCE,
      };

      if (this.task) {
        // Pega o parent
        const parentTask = this.WBSRows.findIndex(
          (r) => r.id == WBSStore.task.id
        );
        if (parentTask === -1) return;

        // Pega o todas as linhas que tenha o mesmo conteudo que o parent
        const allSameContent = WBSStore.getListByContent(
          this.WBSRows[parentTask].data.contentId,
          this.WBSRows[parentTask].id
        );

        for (const row of allSameContent) {
          const childrenRow = this.WBSRows.find(
            (r) =>
              r.data.parentTask == row.id &&
              r.data.rowIndex == line.data.rowIndex
          );
          if (childrenRow) {
            let lineRef = this.WBSRef.collection("rows").doc(childrenRow.id);
            actions.push({
              type: "update",
              args: [lineRef, update],
              arrayChange: async () => {
                WBSStore.changeAllArray(update, childrenRow);
              },
            });
          }
        }
      } else {
        let lineRef = this.WBSRef.collection("rows").doc(line.id);
        actions.push({
          type: "update",
          args: [lineRef, update],
          arrayChange: async () => {
            WBSStore.changeAllArray(update, line);
          },
        });
      }
    } else {
      // Se a nova for task tem que criar a estrutura dentro
      if (value == EContentType.TASK) {
        // Muda o contentId para um novo, a linha não estará mais ligada a outras linhas.
        let update = {
          contentType: value,
          contentId: WBSModels.getNewUUID(),
          rowType: ERowType.TASK,
        };

        if (this.task) {
          // Pega o parent
          const parentTask = this.WBSRows.findIndex(
            (r) => r.id == WBSStore.task.id
          );
          if (parentTask === -1) return;

          // Pega o todas as linhas que tenha o mesmo conteudo que o parent
          const allSameContent = WBSStore.getListByContent(
            this.WBSRows[parentTask].data.contentId,
            this.WBSRows[parentTask].id
          );

          for (const row of allSameContent) {
            const childrenRow = this.WBSRows.find(
              (r) =>
                r.data.parentTask == row.id &&
                r.data.rowIndex == line.data.rowIndex
            );

            if (childrenRow) {
              let lineRef = this.WBSRef.collection("rows").doc(childrenRow.id);
              actions.push({
                type: "update",
                args: [lineRef, update],
                arrayChange: async () => {
                  // Cria os 20 campos em branco apontando pro id da task
                  await this.fillEmptyTask(childrenRow.id);
                  WBSStore.changeAllArray(update, childrenRow);
                  // Atualiza o valor para o novo
                  WBSStore.recursiveUpdateWBSSubcollection(
                    undefined,
                    0,
                    undefined,
                    childrenRow.id
                  );
                },
              });
            }
          }
        } else {
          let lineRef = this.WBSRef.collection("rows").doc(line.id);
          actions.push({
            type: "update",
            args: [lineRef, update],
            arrayChange: async () => {
              // Cria os 20 campos em branco apontando pro id da task
              await this.fillEmptyTask(line.id);
              WBSStore.changeAllArray(update, line);
              // Atualiza o valor para o novo
              WBSStore.recursiveUpdateWBSSubcollection(
                undefined,
                0,
                undefined,
                line.id
              );
            },
          });
        }
      } else {
        const filtered = this.getListByContent(line.data.contentId);

        for (let i = 0; i < filtered.length; i++) {
          let lineRef = this.WBSRef.collection("rows").doc(filtered[i].id);
          actions.push({
            type: "update",
            args: [lineRef, { contentType: value }],
            arrayChange: () => {
              WBSStore.changeAllArray({ contentType: value }, filtered[i]);
            },
          });
        }
      }
    }
    await this.batchActions(actions, false);
  }

  /** Obtém a estrutura abaixo/dentro da linha informada. */
  recursiveRowGet(id: any) {
    let lines = new Array();
    let filtred = this.WBSRows.filter(
      (r) => (r.data.parentStage || r.data.parentTask) == id
    );
    for (let i = 0; i < filtred.length; i++) {
      let data: any = [];
      if (
        filtred[i].data.rowType == ERowType.TASK ||
        filtred[i].data.rowType == ERowType.STAGE
      ) {
        data = this.recursiveRowGet(filtred[i].id);
      }
      lines.push({ row: filtred[i], data });
    }
    return lines;
  }

  recursiveRowDelete(id: any) {
    let actions = new Array();
    let filtred = this.WBSRows.filter(
      (r) => (r.data.parentStage || r.data.parentTask) == id
    );
    for (let i = 0; i < filtred.length; i++) {
      let lineRef = this.WBSRef.collection("rows").doc(filtred[i].id);
      actions.push({
        type: "delete",
        args: [lineRef],
      });
      if (
        filtred[i].data.rowType == ERowType.TASK ||
        filtred[i].data.rowType == ERowType.STAGE
      ) {
        actions.push(...this.recursiveRowDelete(filtred[i].id));
      }
    }
    return actions;
  }

  @action
  async updateTaskRow(line, clmn, newValue) {
    if (clmn !== "quantity")
      this.WBSRef.collection("rows")
        .doc(this.task.id)
        .update({ [clmn]: newValue })
        .then(() => {
          line.data[clmn] = newValue;
        });
    else {
      let { total } = line.data,
        actions = new Array(),
        update = {
          total: times(
            newValue,
            line.data.unitCost,
            WBSPropertiesStore.getRules(2)
          ),
          quantity: newValue,
        };

      let item = WBSStore.WBSRows.findIndex((r) => r.id == WBSStore.task.id);
      if (item == -1) return;

      let allSameContent = WBSStore.getListByContent(
        WBSStore.WBSRows[item].data.contentId,
        WBSStore.WBSRows[item].id
      );

      for (let j = 0; j < allSameContent.length; j++) {
        let idxSelected = WBSStore.WBSRows.findIndex(
          (r) =>
            allSameContent[j].id == r.data.parentTask &&
            WBSStore.selectedLine.data.rowIndex == r.data.rowIndex
        );
        if (idxSelected == -1) continue;
        let doc = this.WBSRef.collection("rows").doc(line.id);
        actions.push({
          type: "update",
          args: [doc, update],
          arrayChange: () => {
            WBSStore.changeAllArray(update, line);
          },
        });
        let diff = subtract(update.total, total);
        actions.push(
          ...this.createActionsToUpdateParentRows(line.data.parentTask, diff)
        );
      }
      this.batchActions(actions, false);
    }
  }
  @action
  async updateWBSRow(
    line,
    index,
    clmn,
    newValue,
    clmn2 = "",
    newValue2: any = "",
    clmn3 = "",
    newValue3: any = "",
    awaitInnerFunction = false
  ) {
    if (newValue === undefined) {
      newValue = null;
    }
    if (clmn === "bdi") {
      if (newValue < 0) {
        return;
      }

      let { total, totalBdi } = line.data;
      let actions = new Array();
      const rules = WBSPropertiesStore.wbsCalculate;
      let totalSale = this.WBS.data.totalSale;
      let result;

      if (newValue === null) {
        newValue = firebase.firestore.FieldValue.delete();
        const globalBDI = this.WBS.data.bdi.percentual;
        result = CalculateWBSService.calculateRowBdi(
          line.data,
          total,
          globalBDI,
          rules
        );
      } else {
        result = CalculateWBSService.calculateRowBdi(
          line.data,
          total,
          newValue,
          rules
        );
      }

      const newTotalSale = result ? result.totalSale : 0;
      let update = {
        totalBdi: newTotalSale,
        vendaBdi: result ? result.unitCostSale : 0,
        bdi: newValue,
      };

      const diff = newTotalSale - (clmn2 === "totalBdi" ? newValue2 : totalBdi);
      if (line.data.parentStage === -1) {
        WBSService.setTotalSales(diff, totalSale, this.WBSRef);
      } else {
        let returnActions = await this.recalcRecursiveStages(line, diff);
        actions = [...returnActions];
        WBSService.setTotalSales(diff, totalSale, this.WBSRef);
      }

      let doc = this.WBSRef.collection("rows").doc(line.id);
      actions.push({
        type: "update",
        args: [doc, update],
      });
      await this.batchActions(actions, false);
    } else if (clmn !== "quantity") {
      let updateData =
        clmn2 === ""
          ? { [clmn]: newValue }
          : { [clmn]: newValue, [clmn2]: newValue2 };
      if (clmn3 !== "") updateData[clmn3] = newValue3;
      this.updateWBSSubcollection(
        line.id,
        line.data.contentId,
        updateData
      ).then(() => {
        line.data[clmn] = newValue;
        if (clmn2 !== "") line.data[clmn2] = newValue2;
        if (clmn3 !== "") line.data[clmn3] = newValue3;
        this.dataTable[0] = { ...this.dataTable[0] };
      });
    } else {
      let { total, parentStage, parentTask, totalBdi } = line.data;
      const rules = WBSPropertiesStore.getRules(2);

      let update;
      let actions = new Array();
      const newTotal = times(newValue, line.data.unitCost, rules);

      const bdi = this.getBdiForRow(line.data);
      let result = CalculateWBSService.calculateRowBdi(
        { ...line.data, quantity: newValue },
        newTotal,
        bdi,
        WBSPropertiesStore.getRules()
      );
      const newTotalSale = result ? result.totalSale : 0;
      const newUnitCostSale = result ? result.unitCostSale : 0;
      /* *
       * Criar uma função para pegar as linhas pelo contentId e depois ver quais dessas estão sómente na EAP
       * e fazer a conta do [Preço de Total] e do [Preço de Venda] e recalcular o [Preço de Total de Venda]
       * somente dessas linhas
       * */
      if (!line.data.parentTask) {
        update = {
          total: roundBy(newTotal, rules),
          quantity: newValue,
          totalBdi: newTotalSale,
          vendaBdi: newUnitCostSale,
        };
      } else {
        update = {
          total: roundBy(newTotal, rules),
          quantity: newValue,
        };
      }
      //
      if (clmn2 !== "" && clmn2 !== "totalBdi") update[clmn2] = newValue2;
      if (clmn3 !== "") update[clmn3] = newValue3;
      //
      // Essa parte limpa o campo formula quando um quantitativo de model map é atrobuido a linha.
      // if (
      //   clmn2 !== "formula" &&
      //   clmn3 !== "formula" &&
      //   clmn == "quantity" &&
      //   clmn2 == "takeOffQuantity" &&
      //   clmn3 == "fromModelMap"
      // )
      //   update["formula"] = "";
      //
      let doc = this.WBSRef.collection("rows").doc(line.id);
      actions.push({
        type: "update",
        args: [doc, update],
        arrayChange: () => {
          try {
            WBSStore.changeAllArray(update, line); // Atualiza o total da quantidadechangeAllArray(update, line);
          } catch (error) {
            console.log(error);
          }
        },
      });

      // Pega o total atualizado
      if (total != 0) {
        // PRUBK-836 - Para evitar diferenças entre os totais das etapas
        total = roundBy(total, rules);
      }

      // PRUBK-836 - Para evitar diferenças entre os totais das etapas
      let diff = subtract(update.total, total);
      let diffBdi = subtract(newTotalSale, totalBdi);
      actions.push(
        ...this.createActionsToUpdateParentRows(
          parentStage ? parentStage : parentTask,
          diff,
          diffBdi
        )
      );
      if (awaitInnerFunction) {
        await this.batchActions(actions, false);
      } else {
        this.batchActions(actions, false);
      }
    }
  }

  /**
   * Função responsável para atualizar a quantidade total dos insumos no orçamento
   * @param line Linha do insumo para recalcular a quantidade total
   */
  private updateResourcesTotalQtt(line: any) {
    let resourcesToUpdate = new Array();
    // Se a linha for composição, deve atualizar o total de todos os insumos internos recursivamente
    if (line.data.rowType === ERowType.TASK) {
      // Recupera as linhas de dentro da task
      resourcesToUpdate = this.getAllResourcesFromTask(line.id);
    }

    // Se a linha for insumo, deve atualizar o total do insumo
    else if (line.data.rowType === ERowType.RESOURCE) {
      resourcesToUpdate.push(line.data.contentId);
    }
    // Executa a função responsável por fazer a manutenção das informações salvas com as quantidades totais dos insumos
    this.restoreResourceTotalQuantity(resourcesToUpdate);
  }

  @action
  async clearResourcesDataTable() {
    this.resourcesDataTable = [];
  }

  /**
   * Carrega as informações para exibir na aba de insumos do projeto
   */
  async loadResourcesData() {
    let allResources: any = [];
    let tempResource: any = {};
    let resources = WBSStore.WBSRows.filter(
      (r) => r.data.rowType == ERowType.RESOURCE
    );
    // Recupera as quantidades totais dos insumos
    let resourcesTotals = await this.getWBSResources();
    let saveTotals = new Array();

    for (let i = 0; i < resources.length; i++) {
      // Não salva 2 itens com o mesmo contentId, porque pra regra de negócio eles são o mesmo item
      let alreadyExistInList =
        allResources.findIndex(
          (ar) => ar.contentId && ar.contentId == resources[i].data.contentId
        ) != -1;
      if (alreadyExistInList) {
        continue;
      }

      let resourceQttTotal = resourcesTotals.filter(
        (r) => r.id === resources[i].data.contentId
      );
      let qttTotal = 0;
      // Se existe quantidade total calculada do insumos, apenas utiliza a mesma
      if (resourceQttTotal.length === 1) {
        qttTotal = resourceQttTotal[0].qtt;
      }
      // Se não existir quantidade total calculada, efetua tratamento de cálculo recursivo
      else {
        qttTotal = this.getResourceQuantity(resources[i]);
        // Persiste o novo total calculado para não precisar calcular novamente em carregamentos posteriores
        saveTotals.push({ id: resources[i].data.contentId, total: qttTotal });
      }
      tempResource = {};
      tempResource.unitCost = resources[i].data.unitCost;
      tempResource.quantity = qttTotal;
      tempResource.contentId = resources[i].data.contentId;
      tempResource.parentStage = resources[i].data.parentStage;
      tempResource.parentTask = resources[i].data.parentTask;
      tempResource.total_cost = times(
        tempResource.quantity,
        tempResource.unitCost,
        WBSPropertiesStore.getRules(2)
      );
      tempResource.description = resources[i].data.description;
      tempResource.unit = resources[i].data.unit;
      tempResource.contentType = resources[i].data.contentType;
      tempResource.rowCode = resources[i].data.rowCode;
      tempResource.origin = resources[i].data.rateLibraryId ? "RL" : "WBS"; // TODO-706 - Origem
      tempResource.index = i;
      tempResource.id = resources[i].id;
      tempResource.WBSRowsIndex = resources[i].WBSRowsIndex;
      allResources.push(tempResource);
    }

    if (saveTotals.length > 0) {
      // Chama função assíncrona para gravar novos totais calculados, se houver algum
      WBSStore.updateWBSResourcesTotals(saveTotals);
    }

    // Ordena pelo custo total do maior para o menor
    this.orderResourcesBy(allResources, "total_cost");
    return this.calculatePercentage();
  }

  getResourceQuantity(
    resource,
    diagramSheetId?,
    taskSheetId?,
    diagramCode?,
    taskCode?
  ) {
    let somarAoTotal = 0;
    let allRows: any = [];
    if (diagramSheetId == undefined) {
      allRows = WBSStore.getListByContent(resource.data.contentId);
    } else {
      allRows = WBSStore.getListByContent(undefined, resource.id);
    }
    // Percorre todos os itens com o mesmo conteudo
    for (let i = 0; i < allRows.length; i++) {
      const row = allRows[i];
      let parent = row.data.parentTask;

      let objectParent = WBSStore.WBSRows.find((r) => r.id == parent);

      let tasksCumulativeQtt = 1;
      while (objectParent) {
        let quantityString: string | undefined = objectParent.data.quantity
          ? objectParent.data.quantity.toString()
          : undefined;
        let quantityRevised = 0;
        if (quantityString) {
          quantityString.search(/[,]/g) === -1
            ? (quantityRevised = objectParent.data.quantity || 0)
            : (quantityRevised = parseFloat(quantityString.replace(",", ".")));
        } else {
          quantityRevised = objectParent.data.quantity || 0;
        }
        tasksCumulativeQtt = tasksCumulativeQtt * (quantityRevised || 0);
        // tasksCumulativeQtt = tasksCumulativeQtt * (objectParent.data.quantity  0);
        let taskParent = objectParent.data.parentTask;
        if (
          taskParent == undefined &&
          diagramSheetId != undefined &&
          taskSheetId != undefined
        ) {
          let taskStage = objectParent.data.parentStage;
          objectParent = WBSStore.WBSRows.find((r) => r.id == taskStage);
          if (
            objectParent &&
            objectParent.data.customProperties &&
            objectParent.data.customProperties[diagramSheetId] &&
            objectParent.data.customProperties[taskSheetId]
          ) {
            if (
              objectParent.data.customProperties[diagramSheetId] !=
                diagramCode ||
              objectParent.data.customProperties[taskSheetId] != taskCode
            ) {
              return 0;
            }
          }
        }
        objectParent = WBSStore.WBSRows.find((r) => r.id == taskParent);
      }

      let quantityString: string | undefined = row.data.quantity
        ? row.data.quantity.toString()
        : undefined;
      let quantityRevised = 0;
      if (quantityString) {
        quantityString.search(/[,]/g) === -1
          ? (quantityRevised = row.data.quantity || 0)
          : (quantityRevised = parseFloat(quantityString.replace(",", ".")));
      } else {
        quantityRevised = row.data.quantity || 0;
      }
      somarAoTotal = sum(
        somarAoTotal,
        times(quantityRevised, tasksCumulativeQtt)
      );
    }
    return somarAoTotal;
  }

  orderResourcesBy(list, value) {
    let listTmp = toJS(list);
    listTmp.sort((a, b) => {
      let c = convert(a[value]);
      let d = convert(b[value]);

      if (c < d) return -1;
      if (c > d) return 1;
      return 0;
    });

    if (WBSStore.orderBy === value && WBSStore.orderByDirection === "desc") {
      WBSStore.orderByDirection = "asc";
    } else {
      WBSStore.orderBy = value;
      WBSStore.orderByDirection = "desc";
      listTmp.reverse();
    }

    WBSStore.resourcesDataTable = listTmp;
    CustomPropertyStore.reloading = true;
    return listTmp;

    function convert(value: any) {
      return isNaN(value)
        ? String(value || "").toUpperCase()
        : Number(value || 0);
    }
  }

  calculatePercentage() {
    let projectTotalCost = 0;
    for (let i = 0; i < WBSStore.resourcesDataTable.length; i++) {
      projectTotalCost = sum(
        projectTotalCost,
        WBSStore.resourcesDataTable[i].total_cost
      );
    }

    let listTmp = toJS(WBSStore.resourcesDataTable);
    let unorderedListTmp = WBSStore.resourcesDataTable.slice();
    // Ordena do maior para o menor
    listTmp.sort((a, b) => {
      let c = isNaN(a["total_cost"]) ? 0 : a["total_cost"];
      let d = isNaN(b["total_cost"]) ? 0 : b["total_cost"];
      return c < d ? 1 : c > d ? -1 : 0;
    });

    let cumulative_percentage = 0;
    listTmp.forEach((element) => {
      element.percentage = (element.total_cost * 100) / projectTotalCost;
      cumulative_percentage += element.percentage;
      element.cumulative_percentage = cumulative_percentage;
      for (let i = 0; i < unorderedListTmp.length; i++) {
        if (unorderedListTmp[i].id === element.id) {
          unorderedListTmp[i] = element;
        }
      }
    });

    WBSStore.resourcesDataTable = listTmp;
    return unorderedListTmp;
  }

  /**
   * Função responsável para recuperar de forma recursiva todos os ids dos insumos de dentro de uma composição específica
   * @param taskId Id da composição para a qual queremos recuperar todos os insumos
   */
  getAllResourcesFromTask(taskId) {
    let resourcesRecovered = new Array();
    let taskRows = this.WBSRows.filter((r) => r.data.parentTask == taskId);
    for (const taskRow of taskRows) {
      if (taskRow.data.rowType === ERowType.RESOURCE) {
        resourcesRecovered.push(taskRow.data.contentId);
      } else if (taskRow.data.rowType === ERowType.TASK) {
        resourcesRecovered = resourcesRecovered.concat(
          this.getAllResourcesFromTask(taskRow.id)
        );
      }
    }
    return resourcesRecovered;
  }

  /**
   * Função responsável por remover uma quantidade total desatualizada e persistir, condicionalmente, a nova quantidade calculada
   * @param resourceIds Array de contentIds de insumos para tratar as quantidades totais
   * @param saveNewTotal Parâmetro opcional para identificar quando deve ser salvo o novo cálculo de quantidade total
   */
  async restoreResourceTotalQuantity(resourceIds, saveNewTotal?: true) {
    // Array de actions para remover da coleção de resources todas as quantidades calculadas dos insumos que foram alterados
    let actions = resourceIds.reduce((filtered, id) => {
      if (id && this.WBSRef) {
        let ref = this.WBSRef.collection("resources").doc(id);
        filtered.push({ type: "delete", args: [ref] });
      }
      return filtered;
    }, []);

    // Efetiva as exclusões das quantidades
    await this.batchActions(actions, false).then(() => {
      // Se a função foi chamada para gravar nova quantidade total
      if (saveNewTotal) {
        let resources = WBSStore.WBSRows.filter(
          (r) => resourceIds.indexOf(r.data.contentId) > 0
        );
        let updateResources = new Array();
        let setActions = new Array();

        for (let i = 0; i < resources.length; i++) {
          if (
            updateResources.findIndex(
              (r) => r === resources[i].data.contentId
            ) === -1
          ) {
            updateResources.push(resources[i].data.contentId);
            let qttTotal = this.getResourceQuantity(resources[i]);
            setActions.push({
              id: resources[i].data.contentId,
              total: qttTotal,
            });
          }
        }
      }
    });

    return;
  }

  /*
    Atualiza o total das linhas recursivamente
    id = Id da primeira linha a ser atualizada
    diff = Diferença entre o valor antigo e o novo
    updateTotal = Se falso, não atualizará o total, é usado quando apenas agrupar ou separar itens dentro de um stage
    neste caso apenas o valor do stage deve mudar, mas não o total já que a linha continuará existindo
  */
  createActionsToUpdateParentRows(
    id: string | number | undefined = -1,
    diff: number = 0,
    diffBdi: number | undefined = 0,
    updateTotal: boolean = true
  ) {
    const actions = new Array();
    const rules = WBSPropertiesStore.getRules(2);
    let oldDiff = diff;
    let oldDiffBdi: number = 0;

    if (diff === 0) return actions;

    // Atualiza os valores de cada pai acima da linha até chegar no
    // 1º nível da EAP
    while (id !== -1) {
      const row = WBSStore.WBSRows.find((d) => d.id == id);
      if (!row || !row.data) {
        id = -1;
        continue;
      }

      let updated: any = {};
      const total = row.data.total || 0;

      if (row.data.rowType === ERowType.TASK) {
        const quantity = row.data.quantity || 0;
        const unitCost = row.data.unitCost || 0;

        // Quando for TASK deve atualizar o custo unitário
        updated.unitCost = sum(unitCost, diff, rules);
        updated.total = times(updated.unitCost, quantity, rules);
        diff = subtract(updated.total, total);

        const bdi = this.getBdiForRow(row.data);
        const result = CalculateWBSService.calculateRowBdi(
          { ...row.data, unitCost: updated.unitCost },
          updated.total,
          bdi,
          WBSPropertiesStore.wbsCalculate
        );

        updated.totalBdi = result ? result.totalSale : 0;
        updated.vendaBdi = result ? result.unitCostSale : 0;

        diffBdi = result ? result.diffBdi : 0;
        oldDiffBdi = sum(diffBdi, oldDiffBdi);
      } else {
        updated.total = sum(total, diff, rules);
        updated.totalBdi = sum(row.data.totalBdi || 0, diffBdi, rules);
      }

      // Cria objeto para atualização
      const doc = this.WBSRef.collection("rows").doc(id);
      actions.push({
        type: "update",
        args: [doc, { ...updated }],
      });

      // Atualiza os valores da composição aberta e
      // repassa as atualizações para todos as listas do sistema
      if (row && this.task.id == row.id) {
        this.task.data.unitCost = updated.unitCost;
        this.taskUnitCost = updated.unitCost;
      }
      WBSStore.changeAllArray(updated, row);

      if (updateTotal) {
        id = row.data.parentStage ? row.data.parentStage : row.data.parentTask;
      } else {
        id = -1;
      }
    }

    // Atualiza os totais do Plano de Custo
    if (updateTotal) {
      actions.push(this.setNewWbsTotal(diff, diffBdi));
    }

    return actions;
  }

  setNewWbsTotal(diff, diffBdi?) {
    if (isNaN(diff)) {
      console.error("diff is NaN");
      diff = 0;
    }
    if (isNaN(diffBdi)) {
      console.error("diffBdi is NaN");
      diffBdi = 0;
    }

    const rules = WBSPropertiesStore.getRules(2);
    let total = sum(this.currentWbsTotalCost, diff, rules);
    let totalSale = sum(this.currentWbsTotalSaleCost, diffBdi, rules);

    this.WBS.data.totalCost = total;
    this.currentWbsTotalCost = total;
    this.totalCost = this.currentWbsTotalCost;
    this.WBS.data.totalSale = total;
    this.currentWbsTotalSaleCost = totalSale;

    return {
      row: this.WBS,
      type: "update",
      args: [this.WBSRef, { totalCost: total, totalSale: totalSale }],
    };
  }

  getListByContent(contentId, id?): Array<IWBSRow> {
    if (contentId == undefined) {
      if (id) {
        return WBSStore.WBSRows.filter((r) => r.id == id);
      } else {
        return [];
      }
    } else {
      return WBSStore.WBSRows.filter((r) => r.data.contentId == contentId);
    }
  }

  @action
  async recursiveUpdateWBSSubcollection(
    contentId: string | undefined,
    unitCost,
    oldResult?,
    id?,
    needReturnActions?,
    diffBdi_?
  ) {
    const actions = new Array();
    const { roundingRule } = WBSPropertiesStore.wbsCalculate;
    const rules = WBSPropertiesStore.getRules(2);
    const filtered = this.getListByContent(contentId, id);

    for (let i = 0; i < filtered.length; i++) {
      const line = filtered[i].data;
      const quantity = line.rowType == ERowType.STAGE ? 1 : line.quantity || 0;

      const oldTotal = calculateOldRowTotal(oldResult, quantity, line);
      const total = times(quantity, unitCost, rules);
      const diff = subtract(total, oldTotal);

      const updatedData: any = createObjWithUpdatedData(
        total,
        unitCost,
        line,
        diffBdi_
      );
      const rowAction = this.changeModelsAndCreateUpdateActionOfRow(
        filtered[i],
        updatedData
      );

      const bdi = this.getBdiForRow(line);
      const bdiDiff = CalculateWBSService.calculateDiffOfBdiTotalSale(
        bdi,
        total,
        oldTotal,
        roundingRule
      );

      const parentsActions = this.createActionsToUpdateParentRows(
        line.parentStage ? line.parentStage : line.parentTask,
        diff,
        bdiDiff
      );

      actions.push(rowAction, ...parentsActions);
    }

    if (needReturnActions) {
      return actions;
    }

    await this.batchActions(actions, false);
    return;

    function calculateOldRowTotal(
      oldResult,
      quantity: number,
      row: WBSRows
    ): number {
      oldResult =
        oldResult != undefined
          ? oldResult
          : times(quantity, row.unitCost || 0, rules);
      return roundBy(oldResult, rules);
    }

    function createObjWithUpdatedData(
      total: number,
      unitCost: number,
      row: WBSRows,
      diffBdi: number
    ) {
      const globalBDI = WBSStore.WBS.data.bdi.percentual;
      const updatedData: any = { total };

      if (row.rowType != ERowType.STAGE) {
        updatedData.unitCost = roundBy(unitCost, WBSPropertiesStore.getRules());

        const result = CalculateWBSService.calculateRowBdi(
          row,
          total,
          globalBDI,
          WBSPropertiesStore.wbsCalculate
        );
        if (result) {
          updatedData.totalBdi = result.totalSale;
          updatedData.vendaBdi = result.unitCostSale;
        }
      } else {
        updatedData.totalBdi = (row.totalBdi || 0) + (diffBdi || 0);
      }
      return updatedData;
    }
  }

  @action
  async recursiveUpdateOfItemQuantityInTask(
    contentId: string | undefined,
    quantity,
    parentTask: string = ""
  ) {
    const actions = new Array();
    const { roundingRule } = WBSPropertiesStore.wbsCalculate;
    const rules = WBSPropertiesStore.getRules(2);
    const filtered = this.getListByContent(contentId);
    const parentRowsUid = this.getParentsTaskRowsUid(parentTask);

    for (let i = 0; i < filtered.length; i++) {
      const line = filtered[i].data;
      if (cannotUpdateRow(line)) continue;

      const oldTotal = times(line.quantity || 0, line.unitCost || 0, rules);
      const total = times(quantity, line.unitCost || 0, rules);
      const diff = subtract(total, oldTotal);

      const updatedData: any = { total, quantity };
      const rowAction = this.changeModelsAndCreateUpdateActionOfRow(
        filtered[i],
        updatedData
      );

      const bdi = this.getBdiForRow(line);
      const bdiDiff = CalculateWBSService.calculateDiffOfBdiTotalSale(
        bdi,
        total,
        oldTotal,
        roundingRule
      );

      const parentsActions = this.createActionsToUpdateParentRows(
        line.parentStage ? line.parentStage : line.parentTask,
        diff,
        bdiDiff
      );

      actions.push(rowAction, ...parentsActions);
    }

    await this.batchActions(actions, false);
    return;

    function cannotUpdateRow(row: WBSRows) {
      return (
        row.rowType == ERowType.STAGE ||
        !parentRowsUid.includes(row.parentTask || "")
      );
    }
  }

  private getParentsTaskRowsUid(parentTask: string): string[] {
    const parentRow = this.getListByContent(undefined, parentTask);
    const parentContentId = parentRow[0] ? parentRow[0].data.contentId : "";

    return this.getListByContent(parentContentId).map((row) => row.id);
  }

  private changeModelsAndCreateUpdateActionOfRow(
    rowData: any,
    updatedData: any
  ): { type: string; args: any[] } {
    WBSStore.changeAllArray({ ...updatedData }, rowData);
    return {
      type: "update",
      args: [
        this.WBSRef.collection("rows").doc(rowData.id),
        { ...updatedData },
      ],
    };
  }

  getBdiForRow(row: WBSRows) {
    const globalBDI = this.WBS.data.bdi.percentual;
    return row.bdi === undefined ? globalBDI : row.bdi;
  }

  // PRUBK-795: alterei newValue para newValue: any = '', para que a variável não receba valor undefined
  async handleWBSTableChange(
    line,
    index,
    ref,
    clmn,
    newValue: any = "",
    clmn2 = "",
    newValue2: any = "",
    clmn3 = "",
    newValue3: any = "",
    awaitInnerFunction = false,
    fromTakeOff: boolean = false
  ) {
    this.selectedColumn = clmn;
    if (line.data.rowType === ERowType.BLANK) {
      WBSStore.createWBSResource(
        line,
        index,
        ref,
        clmn,
        newValue,
        clmn2,
        newValue2
      );
      ToolbarStore.handelActions({
        originalOperation: "createWBSResource",
        undoOperation: "reverseWBSResourceToBlank",
        data: {
          undoFunction: {
            function: "reverseWBSResourceToBlank",
            params: [line],
            selectedLine: [],
          },
          originalFunction: {
            function: "createWBSResource",
            params: [line, index, clmn, newValue, clmn2, newValue2],
          },
        },
      });
    } else if (line.data.rowType === ERowType.STAGE) {
      WBSStore.updateWBSSubcollection(line.id, line.data.contentId, {
        description: newValue,
      }).then(() => {});
    } else {
      if (ref === "row") {
        if (awaitInnerFunction) {
          await WBSStore.updateWBSRow(
            line,
            index,
            clmn,
            newValue,
            clmn2,
            newValue2,
            clmn3,
            newValue3,
            awaitInnerFunction
          );
        } else {
          if (fromTakeOff) {
            WBSStore.updateWBSRow(
              line,
              index,
              clmn,
              newValue,
              clmn2,
              newValue2,
              clmn3,
              newValue3
            );
          } else {
            WBSStore.updateWBSRow(
              line,
              index,
              clmn,
              newValue,
              clmn2,
              newValue2,
              clmn3,
              newValue3
            );
            ToolbarStore.handelActions({
              originalOperation: "updateWBSRow",
              undoOperation: "updateWBSRow",
              data: {
                undoFunction: {
                  function: "updateWBSRow",
                  params: [
                    WBSStore.oldSelectedLine,
                    WBSStore.oldSelectedLine.index,
                    WBSStore.oldSelectedLine.dataKey,
                    WBSStore.oldSelectedLine.data &&
                    WBSStore.oldSelectedLine.dataKey === "bdi"
                      ? WBSStore.oldSelectedLine.data.bdi
                      : WBSStore.oldSelectedLine.data.quantity,
                  ],
                  selectedLine: [],
                },
                originalFunction: {
                  function: "updateWBSRow",
                  params: [
                    line,
                    index,
                    clmn,
                    newValue,
                    clmn2,
                    newValue2,
                    clmn3,
                    newValue3,
                  ],
                },
              },
            });
          }
        }
      } else {
        if (["description", "unit", "rowCode"].find((itm) => itm === clmn)) {
          const _linha = WBSStore.oldSelectedLine;
          let oldValueOfEditField = { [clmn]: _linha.data[clmn] };

          WBSStore.updateWBSSubcollection(line.id, line.data.contentId, {
            [clmn]: newValue,
          });
          ToolbarStore.handelActions({
            originalOperation: "updateWBSSubcollection",
            undoOperation: "updateWBSSubcollection",
            data: {
              undoFunction: {
                function: "updateWBSSubcollection",
                params: [
                  WBSStore.oldSelectedLine.id,
                  WBSStore.oldSelectedLine.data.contentId,
                  oldValueOfEditField,
                ],
                selectedLine: [],
              },
              originalFunction: {
                function: "updateWBSSubcollection",
                params: [line.id, line.data.contentId, { [clmn]: newValue }],
              },
            },
          });
        } else {
          const unitCost = WBSStore.oldSelectedLine.data.unitCost;

          WBSStore.recursiveUpdateWBSSubcollection(
            line.data.contentId,
            newValue
          );
          await ToolbarStore.handelActions({
            originalOperation: "recursiveUpdateWBSSubcollection",
            undoOperation: "recursiveUpdateWBSSubcollection",
            data: {
              undoFunction: {
                function: "recursiveUpdateWBSSubcollection",
                params: [WBSStore.oldSelectedLine.data.contentId, unitCost],
                selectedLine: [],
              },
              originalFunction: {
                function: "recursiveUpdateWBSSubcollection",
                params: [line.data.contentId, newValue],
              },
            },
          });
        }
      }
    }
    if (!WBSStore.updateResource) {
      WBSStore.updateResource = true;
    }
  }

  /**************************************************************************************************
   *   ╔════════════════════════════════════════════════════════════════════════════════════════╗    *
   *   ║   Função acionada quando são alterados os valores diretamente nas linhas da TaskRows   ║    *
   *   ╚════════════════════════════════════════════════════════════════════════════════════════╝    *
   ***************************************************************************************************/
  async handleWBSTableChangeTask(line, index, ref, clmn, newValue) {
    WBSStore.loadingTaskChange = true;
    if (line.data.rowType === ERowType.BLANK) {
      ToolbarTaskStore.handelActions(
        WBSStore.createTaskRowResource(line, index, ref, clmn, newValue).then(
          () => {
            WBSStore.taskRows[index].data[clmn] = newValue;
          }
        ),
        {
          originalOperation: "createTaskRowResource",
          undoOperation: "deleteTaskRow",
          data: {
            undoFunction: {
              function: "deleteTaskRow",
              params: [],
              selectedLine: [WBSStore.selectedLine],
            },
            originalFunction: {
              function: "createTaskRowResource",
              params: [line, index, clmn, newValue],
            },
          },
        }
      );
    } else {
      if (ref === "row") {
        // console.log("<<<<<<<<<<<   Quantidade   >>>>>>>>>>>")
        if (clmn === "calculateQuantity") {
          const accumulated = this.getCurrentTaskAccumulatedQuantity();
          newValue =
            accumulated === 0
              ? 0
              : divide(newValue, accumulated, WBSPropertiesStore.getRules(4));
          await this.changeItemQuantityInTask(line, newValue);
        } else if (clmn === "quantity") {
          await this.changeItemQuantityInTask(line, newValue);
        } else {
          ToolbarTaskStore.handelActions(
            WBSStore.updateTaskRow(line, clmn, newValue),
            {
              originalOperation: "updateTaskRow",
              undoOperation: "updateTaskRow",
              data: {
                undoFunction: {
                  function: "updateTaskRow",
                  params: [
                    WBSStore.oldSelectedLine,
                    WBSStore.oldSelectedLine.dataKey,
                    WBSStore.oldSelectedLine.data.quantity,
                  ],
                  selectedLine: [],
                },
                originalFunction: {
                  function: "updateTaskRow",
                  params: [line, clmn, newValue],
                },
              },
            }
          );
        }
      } else {
        if (["description", "unit", "rowCode"].find((itm) => itm === clmn)) {
          // console.log("<<<<<<<<<<<   Descrição & Unidade   >>>>>>>>>>>")
          const _linha = WBSStore.oldSelectedLine;
          let oldValueOfEditField = { [clmn]: _linha.data[clmn] };

          ToolbarTaskStore.handelActions(
            WBSStore.updateWBSSubcollection(line.id, line.data.contentId, {
              [clmn]: newValue,
            }),
            {
              originalOperation: "updateWBSSubcollection",
              undoOperation: "updateWBSSubcollection",
              data: {
                undoFunction: {
                  function: "updateWBSSubcollection",
                  params: [
                    WBSStore.oldSelectedLine.id,
                    WBSStore.oldSelectedLine.data.contentId,
                    oldValueOfEditField,
                  ],
                  selectedLine: [],
                },
                originalFunction: {
                  function: "updateWBSSubcollection",
                  params: [line.id, line.data.contentId, { [clmn]: newValue }],
                },
              },
            }
          );
        } else {
          // console.log("<<<<<<<<<<<   Custo Unitário  >>>>>>>>>>>")
          const unitCost = WBSStore.oldSelectedLine.data.unitCost;
          await ToolbarTaskStore.handelActions(
            WBSStore.recursiveUpdateWBSSubcollection(
              line.data.contentId,
              newValue
            ),
            {
              originalOperation: "recursiveUpdateWBSSubcollection",
              undoOperation: "recursiveUpdateWBSSubcollection",
              data: {
                undoFunction: {
                  function: "recursiveUpdateWBSSubcollection",
                  params: [WBSStore.oldSelectedLine.data.contentId, unitCost],
                  selectedLine: [],
                },
                originalFunction: {
                  function: "recursiveUpdateWBSSubcollection",
                  params: [line.data.contentId, newValue],
                },
              },
            }
          );
        }
      }
    }

    await this.timeout(1200);
    WBSStore.setSelectedLine(WBSStore.selectedLine.index, clmn, true);
    WBSStore.loadingTaskChange = false;
    if (!WBSStore.updateResource) {
      WBSStore.updateResource = true;
    }
  }

  private async changeItemQuantityInTask(line, newQuantity: number) {
    const oldContentId = WBSStore.oldSelectedLine.data.contentId;
    const oldQuantity = WBSStore.oldSelectedLine.data.quantity;
    const oldParentContentId = WBSStore.oldSelectedLine.data.parentTask;

    const contentId = line.data.contentId;
    const parentContentId = WBSStore.task.id;

    await ToolbarTaskStore.handelActions(
      WBSStore.recursiveUpdateOfItemQuantityInTask(
        contentId,
        newQuantity,
        parentContentId
      ),
      {
        originalOperation: "recursiveUpdateOfItemQuantityInTask",
        undoOperation: "recursiveUpdateOfItemQuantityInTask",
        data: {
          undoFunction: {
            function: "recursiveUpdateOfItemQuantityInTask",
            params: [oldContentId, oldQuantity, oldParentContentId],
            selectedLine: [],
          },
          originalFunction: {
            function: "recursiveUpdateOfItemQuantityInTask",
            params: [contentId, newQuantity, parentContentId],
          },
        },
      }
    );
  }

  foundUpdatedDocs(actions, diff, stagesActions) {
    for (let actn of stagesActions) {
      let foundAction = actions.find(
        (itm) => itm.args[0].path === actn.args[0].path
      );
      if (foundAction) {
        let ttl = new Array();
        for (let [key, value] of Object.entries(actn.args[1])) {
          if (diff[key] !== 0 && foundAction.type === "update") {
            let [ref, update] = foundAction.args;
            if (typeof update[key] === "number") update[key] += diff[key];
            else update[key] = value;
            ttl.push({ key, value: update[key] });
          }
        }
        let arrayChange = foundAction.arrayChange;
        foundAction.arrayChange = () => {
          arrayChange();
          for (let { key, value } of ttl) actn.row.data[key] = value;
        };
      } else actions.push(actn);
    }
  }

  @action
  async setSelectedTask(task) {
    if (this.task.id == task.id) {
      return;
    }
    this.updateTaskRows(task);
    // Se houver linhas na composição seleciona a primeira linha
    if (this.taskRows.length !== 0) {
      WBSStore.setSelectedLine(0, "description", false);
    } else {
      setTimeout(async () => {
        // Espera para caso ainda esteja criando, se ainda sim estiver vazio, ai cria 1 linha em branco
        if (this.taskRows.length === 0) {
          await this.fillEmptyTask(task.id, 1);
          this.reorderTaskRowsIndex(task.id);
        } else {
          WBSStore.setSelectedLine(0, "description", false);
        }
      }, 1000);
    }
  }

  updateTaskRows(task) {
    const canUpdateUnitCost = task.id !== this.task.id;
    this.task = task;
    if (canUpdateUnitCost) this.taskUnitCost = task.data.unitCost;
    else task.data.unitCost = this.taskUnitCost;
    this.reorderTaskRowsIndex(task.id);
  }

  reorderTaskRowsIndex(taskId: String) {
    this.taskRows = this.orderListByRowIndex(
      this.WBSRows.filter((r) => {
        return r.data.parentTask == taskId;
      })
    );
  }

  @action
  troca = (data) => {
    this.oldSelectedLine = data;
  };

  getCompositionItems = async (compositionId) => {
    let resp = await this.WBSRef.collection("rows")
      .where("parentTask", "==", compositionId)
      .get()
      .then((rows) => {
        let listRows = new Array();
        rows.forEach((row) => {
          if (row.data().description) {
            listRows.push(row.data());
          }
        });
        return listRows;
      });
    resp.sort((a, b) => {
      if (a.rowIndex > b.rowIndex) {
        return 1;
      }
      if (a.rowIndex < b.rowIndex) {
        return -1;
      }
      // A deve ser igual a B
      return 0;
    });
    return resp;
  };
  saveCopiedLine = async (line) => {
    let devId = DevelopmentStore.developmentSelected.id;
    let snapshot = await firestore
      .collection("wbsProjectBudget")
      .where("development", "==", devId)
      .limit(1)
      .get();
    let doc = snapshot.docs[0];
    let ref = doc.ref;
    let data = await ref.collection("rows").add({
      contentId: line.row.data.contentId,
      contentType: line.row.data.contentType,
      description: line.row.data.description,
      parentStage: line.row.data.parentStage,
      quantity: line.row.data.quantity,
      rowIndex: line.row.data.rowIndex,
      rowType: line.row.data.rowType,
      total: line.row.data.total,
      unit: line.row.data.unit,
      unitCost: line.row.data.unitCost,
      totalBdi: line.row.data.totalBdi,
      vendaBdi: line.row.data.vendaBdi,
    });
    return [data, ref];
  };

  findActivityRow(
    rateLibraryId: string,
    rateLibraryCode: string,
    rowType: number
  ) {
    let activity: any = this.WBSRows.find(
      (r) =>
        r.data.rateLibraryId == rateLibraryId &&
        r.data.rateLibraryCode == rateLibraryCode &&
        r.data.rowType == rowType
    );
    let activities: any = [];
    if (activity) {
      activities.push(activity);
    }
    return activities;
  }

  insertRowAtEnd(id: string, rowData) {
    const lastIndex = this.WBSRows.length;
    this.WBSRows[lastIndex] = {
      data: { ...rowData },
      id,
      WBSRowsIndex: lastIndex,
    };
  }

  /**
   * Obtém a quantidade acumulada da atualmente composição aberta.
   * @returns {number} Quantidade acumulada da composição aberta.
   */
  getCurrentTaskAccumulatedQuantity(): number {
    const currentTask = this.task;
    if (currentTask) return this.getRowAccumulatedQuantity(currentTask.id);
    return 0;
  }

  /**
   * Obtém a quantidade acumulada do insumo/composição, caso este pertença
   * ao conteúdo de alguma composição. Para calcular a quantidade acumulada
   * do item o sistema pega a quantidade da composição principal
   * (que está no nível da EAP) multiplica recursivamente pelos coeficientes
   * das composições filhas até chegar no item desejado.
   * Caso o item deseja já esteja no nível da EAP então é retornada apenas
   * sua quantidade.
   *
   * @param {string} rowId ID da linha
   * @returns {number} Quantidade acumulada ou quantidade do item
   */
  getRowAccumulatedQuantity(rowId: string): number {
    const row = this.findWBSRowById(rowId);
    if (!row) return 0;

    let accumulatedQuantity = row.data.quantity || 0;
    let parentTaskId = row.data.parentTask;

    while (parentTaskId) {
      const parentTask = this.findWBSRowById(parentTaskId);
      if (parentTask && parentTask.data.rowType === ERowType.TASK) {
        let parentQtt = parentTask.data.quantity || 0;
        accumulatedQuantity = times(accumulatedQuantity, parentQtt);
        parentTaskId = parentTask.data.parentTask || "";
      } else {
        parentTaskId = "";
      }
    }

    return roundBy(accumulatedQuantity, WBSPropertiesStore.getRules(4));
  }

  /**
   * Inicia o processo de comparar as composições da EAP com os dados
   * vindos do banco de composições e verificar se os itens precisam de
   * código alternativo e grupos de insumos. Exibe seu progresso na tela.
   * @param rateLibraryId ID do banco de composições
   */
  async compareEAPCompositionsWithRateLibrary(rateLibraryId: string) {
    WBSStore.displayUploadOfUpdateComposition("compareCompositions", 0);
    return WBSService.sendToCompareCompositions(
      WBSStore.currentWbsId,
      rateLibraryId
    )
      .then((response) => {
        if (response && response.compositions) {
          this.compositionUpdateProps.alternativeCode =
            response.hasAlternativeCode;
          this.compositionUpdateProps.resourceGroup =
            response.hasDescriptionGroup;

          const list = response.compositions
            .filter((item) => item.status !== "inalterado")
            .map((item) => {
              let list = {
                contentId: item.contentId,
                selected: false,
                status: item.status,
                code: item.rowCode,
                description: item.description,
                unit: item.unit,
                unitCost: item.unitCost,
                newCost:
                  item.newCost != undefined ? item.newCost : item.unitCost,
                rateLibraryId: item.rateLibraryId,
                customProperties: item.customProperties,
                alternativeCodeComposition: item.alternativeCodeComposition,
              };
              return list;
            });
          WBSStore.setCompositionUpdateList(list);
        }
      })
      .catch(function (error) {
        console.log(error);
      });
  }

  displayUploadOfUpdateComposition(type: string, totalCompositions?: number) {
    WBSService.displayUploadOfUpdateComposition(
      type,
      this.WBSRef,
      totalCompositions
    );
  }

  async recalcRecursiveStages(line, dif) {
    let parentStage = this.findEAPRowById(line.data.parentStage);
    let actions = new Array();
    if (parentStage) {
      let stageTotalOld = parentStage!.data.totalBdi;
      let stageTotalNew = stageTotalOld + dif;
      let returnActions = await this.recalcRecursiveStages(parentStage, dif);
      //
      actions = [...actions, ...returnActions];
      let rowsRef = await this.WBSRef.collection("rows").doc(parentStage.id);
      actions.push({
        type: "update",
        args: [rowsRef, { totalBdi: stageTotalNew }],
      });
      //
      return actions;
    } else {
      return actions;
    }
  }

  /**
   * Procura a linha da tabela da EAP com o id informado.
   * @param {string} id ID da linha.
   * @returns {IWBSRow | undefined} Dados da linha.
   */
  findEAPRowById(id: string): IWBSRow | undefined {
    return WBSStore.dataTable.find((el) => el.id === id);
  }

  async unlinkComposition(lineSelected) {
    let lineId = lineSelected.id;
    let oldContentId = lineSelected.data.contentId;
    let newContentId = uuidv4().replace(/-/g, "");
    let resp = await WBSService.unlinkComposition(lineId, newContentId);
    await ToolbarStore.handelActions({
      originalOperation: "unlinkComposition",
      undoOperation: "unlinkComposition",
      data: {
        undoFunction: {
          function: "unlinkComposition",
          params: [lineId, oldContentId],
          selectedLine: [],
        },
        originalFunction: {
          function: "unlinkComposition",
          params: [lineId, newContentId],
        },
      },
    });
    return resp;
  }

  /** Filtra todas as linhas do plano de custo a partir do termo passado, também com a
   * opção de filtrar por insumos ou composições.
   * @param {string} term Termo a ser usado como filtro
   * @param {string} type Define se a lista filtrada conterá todos os tipos de linhas, ou somente insumos, ou somente composições
   * @returns {IWBSRow[]} Lista filtrada
   */
  filterAllRowsWithTerm(term: string, type: string) {
    const filteredRows = this.filterRowsListWithTerm(this.WBSRows, term, type);
    return filteredRows.sort((a, b) => a.WBSRowsIndex - b.WBSRowsIndex);
  }

  /** Filtra a lista de linhas da EAP a partir do termo passado.
   * @param {string} term Termo a ser usado como filtro
   * @returns {IWBSRow[]} Lista filtrada
   */
  filterEAPRowsWithTerm(term: string) {
    const filteredRows = this.filterRowsListWithTerm(this.dataTable, term);
    return filteredRows.sort((a, b) =>
      typeof a.index === "number" && typeof b.index === "number"
        ? a.index - b.index
        : 0
    );
  }

  /** Filtra a lista de linhas da composição em exibição a partir do termo passado.
   * @param {string} term Termo a ser usado como filtro
   * @returns {IWBSRow[]} Lista filtrada
   */
  filterTaskRowsWithTerm(term: string) {
    const filteredRows = this.filterRowsListWithTerm(this.taskRows, term);
    return filteredRows.sort((a, b) =>
      a.data && b.data ? a.data.rowIndex - b.data.rowIndex : 0
    );
  }

  /** Filtra a lista de linhas informada a partir do termo passado. Verificação se o
   * campo descrição contém o termo ou se o valor de uma das propriedades customizadas
   * da linha contém o termo, também com a opção de filtrar por insumos ou composições.
   * @param {IWBSRow[]} rowsList Lista de linhas a ser filtrada
   * @param {string} term Termo a ser usado como filtro.
   * @param {string} type Define se a lista filtrada conterá todos os tipos de linhas, ou somente insumos, ou somente composições.
   * @returns {IWBSRow[]} Lista filtrada.
   */
  filterRowsListWithTerm(
    rowsList: IWBSRow[],
    term: string,
    type: string = "all"
  ): IWBSRow[] {
    if (!term || !rowsList || !rowsList.length) return [];
    term = term.toLowerCase();

    const customPropIds = CustomPropertyStore.getWBSCustomProperties().map(
      (doc) => doc.id
    );

    const filtered = rowsList.filter((row) => {
      const {
        rowType,
        rowCode = "",
        description = "",
        customProperties,
      } = row.data;

      // Se for linha em branco, ignora
      if (rowType === ERowType.BLANK) return false;

      if (type === "resources" && rowType !== ERowType.RESOURCE) return false;
      if (type === "tasks" && rowType !== ERowType.TASK) return false;

      // Se tiver o termo pesquisado na descrição, inclui
      if (description.toLowerCase().includes(term)) return true;

      // Se tiver o termo pesquisado no código da linha, inclui
      if (rowCode.toLowerCase().includes(term)) return true;

      if (customProperties) {
        // Se tiver o termo pesquisado em alguma propriedade customizada e
        // ela existir no plano de custo, inclui
        return Object.entries(customProperties).some(
          ([key, value]) =>
            customPropIds.includes(key) && value.toLowerCase().includes(term)
        );
      }
      // Se não, pula
      return false;
    });

    return filtered;
  }
}

let WBSStore = new Store();

export { WBSStore };



// WEBPACK FOOTER //
// ./src/modules/WBS/WBSStore.tsx